(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atelaye-clay-gems"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('atelaye-clay-gems')) {
  customElements.define('atelaye-clay-gems', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.classList.add('acg-enhanced');
      this.lifecycle = new AbortController();
      const on = (node, event, fn, opts) => node?.addEventListener(event, fn, { signal: this.lifecycle.signal, ...(opts||{}) });
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.radios = [...this.querySelectorAll('[data-offer]')];
      this.form = this.querySelector('.acg-form');
      this.mainBuy = this.querySelector('[data-main-buy]');
      this.stickyBuy = this.querySelector('[data-sticky-buy]');
      this.error = this.querySelector('[data-error-message]');
      this.pending = false;
      const first = this.radios.find(r => !r.disabled);
      if (first && !this.radios.some(r => r.checked && !r.disabled)) first.checked = true;
      /* Galerie-Anbindung, wird unten bei der Galerie belegt: Stein zeigen, Position lesen/setzen. */
      let showStone = () => {};
      let galleryAt = () => 0;
      let galleryGo = () => {};

      const esc = value => String(value == null ? '' : value).replace(/[&<>"']/g, ch => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]));

      /* Inhaltszeile: " — " teilt in Hauptzeile und kleine Zeile darunter, wie in Liquid. */
      const putSplit = (el, value) => {
        const parts = String(value == null ? '' : value).split(' — ');
        const main = parts.shift();
        const sub = parts.join(' — ');
        el.innerHTML = '<span class="acg-inc-main">' + esc(main) + '</span>' + (sub ? '<small class="acg-inc-sub">' + esc(sub) + '</small>' : '');
      };

      /* ---------- Steine ----------
         Alle Steine stehen als Kacheln im Fenster. Die Wahl (bis zu drei Sets) steckt in den
         Feldern properties[Gemstone set 1/2/3]; Liquid hat sie vorbelegt, das Script übernimmt
         sie von dort. */
      const stones = this.querySelector('[data-acg-stones]');
      const sheet = this.querySelector('[data-acg-sheet]');
      this.sheet = sheet;
      this.sheetHome = sheet?.parentNode || null;
      /* Kachel = Rahmen mit zwei Knöpfen: pick wählt (gesperrt, wenn ausverkauft), das Plus öffnet die Details. */
      const SETS = sheet ? [...sheet.querySelectorAll('[data-acg-stone]')].map(el => {
        const pick = el.querySelector('[data-acg-stone-pick]');
        return {
          name: el.dataset.setName || '',
          kind: el.dataset.kind || 'set',
          meta: el.dataset.meta || '',
          count: el.dataset.count || '',
          stones: parseInt(el.dataset.stones || '0', 10) || (el.dataset.kind === 'set' ? 8 : 1),
          thumb: el.dataset.thumb || '',
          swatch: el.dataset.swatch || '',
          files: (el.dataset.files || '').split(',').map(f => f.trim()).filter(Boolean),
          colours: (el.dataset.colours || '').split(',').map(c => c.trim()).filter(c => /^#?[0-9a-z]{3,8}$/i.test(c)),
          available: Boolean(pick) && !pick.disabled,
          el,
          pick
        };
      }) : [];
      const setByName = name => SETS.find(set => set.name === name);
      /* Ohne Foto zeichnet die Kachel die Steine aus den hinterlegten Farben. */
      const gemSvg = set => {
        const cols = set.colours.length ? set.colours : ['#D2CBBB'];
        let out = '<svg viewBox="0 0 100 100" aria-hidden="true" focusable="false">';
        if (set.kind === 'oval') out += '<ellipse cx="50" cy="50" rx="22" ry="27" fill="' + cols[0] + '"/>';
        else if (set.kind === 'emerald') out += '<path d="M35 25h30l7 7v36l-7 7H35l-7-7V32Z" fill="' + cols[0] + '"/>';
        else [[27, 25], [57, 20], [79, 33], [24, 50], [50, 47], [76, 61], [34, 73], [63, 78]].forEach((pt, i) => { out += '<circle cx="' + pt[0] + '" cy="' + pt[1] + '" r="7" fill="' + cols[i % cols.length] + '"/>'; });
        return out + '</svg>';
      };
      SETS.forEach(set => {
        const box = set.el.querySelector('[data-acg-stone-img]');
        if (box && !box.querySelector('img')) box.insertAdjacentHTML('beforeend', gemSvg(set));
      });
      /* Runder Swatch wie im Kit: eigenes Swatch-Bild, sonst das Foto, sonst die Grafik. */
      const swatchHtml = (set, size) => !set ? '' : (set.swatch || set.thumb)
        ? '<img src="' + esc(set.swatch || set.thumb) + '" alt="" width="' + size + '" height="' + size + '" loading="eager" decoding="async">'
        : gemSvg(set);

      const props = [...this.querySelectorAll('input[data-acg-prop]')].sort((a, b) => Number(a.dataset.acgProp) - Number(b.dataset.acgProp));
      const firstFree = SETS.find(set => set.available && set.kind === 'set') || SETS.find(set => set.available);
      this.picks = props.map(input => {
        const set = setByName(input.value);
        return set && set.available ? set.name : (firstFree ? firstFree.name : '');
      });
      const packOf = radio => Math.max(1, Math.min(3, parseInt(radio?.dataset.pack || '1', 10) || 1));
      this.cap = packOf(this.radios.find(r => r.checked && !r.disabled));

      const L = stones ? stones.dataset : {};
      const propBase = L.propBase || 'Gemstone set';
      const slotLabel = i => (L.lSet || '').replace('__N__', String(i + 1));
      /* Namen der Sets, doppelte zusammengefasst: "Rainbow ×2 · Crystal". */
      const chosenNames = (list, joiner) => {
        const out = [];
        list.forEach(name => {
          if (!name || out.some(item => item.name === name)) return;
          out.push({ name, n: list.filter(other => other === name).length });
        });
        return out.map(item => item.name + (item.n > 1 ? ' ×' + item.n : '')).join(joiner || ' · ');
      };
      const stonesTotal = list => list.reduce((sum, name) => sum + (setByName(name)?.stones || 0), 0);

      /* Karte auf der Seite wie im Kit: ein runder Swatch pro Set (Single links mit Name daneben,
         Duo/Trio nebeneinander), darunter im Link vier noch nicht gewählte Steine als Punkte.
         "Gemstone set 1" und "Change stones" stehen nur im aria-label. Ein gewechselter Stein
         blendet weich ein. */
      const rows = [...this.querySelectorAll('[data-acg-st-row]')];
      const stList = this.querySelector('[data-acg-st-list]');
      const stack = this.querySelector('[data-acg-st-stack]');
      const renderRows = () => {
        if (stList) stList.dataset.n = String(this.cap);
        rows.forEach((row, i) => {
          row.hidden = i >= this.cap;
          const set = setByName(this.picks[i]);
          if (!set) return;
          const thumb = row.querySelector('[data-acg-row-thumb]');
          const name = row.querySelector('[data-acg-row-name]');
          if (thumb && (thumb.dataset.name !== set.name || !thumb.firstElementChild)) {
            const swapped = Boolean(thumb.dataset.name) && thumb.dataset.name !== set.name;
            thumb.innerHTML = swatchHtml(set, 128);
            thumb.dataset.name = set.name;
            if (swapped && !row.hidden && !reduceMotion.matches) {
              row.classList.remove('is-swap');
              void row.offsetWidth;
              row.classList.add('is-swap');
            }
          }
          if (name) name.textContent = set.name;
          row.setAttribute('aria-label', (this.cap > 1 ? slotLabel(i) + ': ' : '') + set.name + '. ' + (L.lChange || ''));
        });
        if (stack) {
          const chosen = this.picks.slice(0, this.cap);
          const others = SETS.filter(set => set.available && chosen.indexOf(set.name) === -1);
          const show = [];
          [1, 3, others.length - 3, others.length - 1].forEach(i => { const set = others[i]; if (set && show.indexOf(set) === -1) show.push(set); });
          const key = show.map(set => set.name).join('|');
          if (stack.dataset.key !== key) {
            stack.innerHTML = show.map(set => '<span class="acg-st-dot">' + swatchHtml(set, 52) + '</span>').join('');
            stack.dataset.key = key;
          }
        }
      };

      /* Platzhalter der Inhaltszeilen: {count} Beutel/Sets, {grams} Gramm Clay, {offer} Angebot,
         {sets} gewählte Steine, {stones} Steine gesamt ("1 stone" statt "1 stones"). */
      const fillTemplate = (tpl, radio) => {
        const list = this.picks.slice(0, this.cap);
        const total = stonesTotal(list);
        let out = String(tpl || '');
        if (total === 1) out = out.split('{stones} stones').join('1 stone').split('{stones} Steine').join('1 Stein');
        return out.split('{count}').join(String(this.cap)).split('{grams}').join(String(this.cap * 7)).split('{stones}').join(String(total)).split('{offer}').join(radio?.dataset.name || '').split('{sets}').join(chosenNames(list));
      };

      this.segs = [];
      this.updateOffer = () => {
        const radio = this.radios.find(r => r.checked && !r.disabled);
        this.cap = packOf(radio);
        const variantInput = this.querySelector('input[data-variant-id]');
        if (variantInput) {
          const nextId = radio?.value || '';
          if (variantInput.value !== nextId) {
            variantInput.value = nextId;
            variantInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
          variantInput.disabled = !radio;
        }
        /* "id", "quantity" und properties[Gemstone set N] (nur so viele wie Sets) tragen den Kauf.
           So schickt jedes Script, das das Formular abschickt (z. B. der Warenkorb in der
           Kopfzeile), alles Nötige mit. */
        props.forEach((input, i) => {
          input.value = this.picks[i] || '';
          input.disabled = i >= this.cap;
        });
        const wallets = this.querySelector('[data-wallets]');
        if (wallets) wallets.hidden = !radio || this.pending;
        const active = Boolean(radio) && !this.pending;
        [this.mainBuy, this.stickyBuy].forEach(b => { if (b) b.disabled = !active; });
        const label = this.pending ? this.dataset.labelAdding : radio ? this.dataset.labelAdd : this.dataset.labelUnavailable;
        const total = radio ? radio.dataset.price : '';
        document.dispatchEvent(new CustomEvent('atelaye:price-change', { detail: { cents: radio ? (parseInt(radio.dataset.priceCents || '0', 10) || 0) : 0 } }));
        const ctaLabel = this.querySelector('[data-cta-label]');
        if (ctaLabel) ctaLabel.textContent = label;
        const ctaPrice = this.querySelector('[data-cta-price]');
        if (ctaPrice) ctaPrice.textContent = radio && !this.pending ? '— ' + total : '';
        const stickyLabel = this.querySelector('[data-sticky-label]');
        if (stickyLabel) stickyLabel.textContent = label;
        const stickyName = this.querySelector('[data-sticky-name]');
        if (stickyName) stickyName.textContent = radio ? radio.dataset.name + ' · ' + chosenNames(this.picks.slice(0, this.cap), ', ') : '';
        const stickyPrice = this.querySelector('[data-sticky-price]');
        if (stickyPrice) stickyPrice.textContent = radio && !this.pending ? total : '';
        this.segs.forEach(seg => seg.setAttribute('aria-pressed', String(Boolean(radio) && seg.dataset.value === radio.value)));

        /* "Inside The Duo": Name, Mengen und Steine folgen der Auswahl. */
        const incOffer = this.querySelector('[data-inc-offer]');
        if (incOffer && radio) incOffer.textContent = radio.dataset.name;
        if (radio) {
          this.querySelectorAll('[data-inc-tpl]').forEach(el => {
            const tpl = (this.cap === 1 ? el.dataset.templateOne : el.dataset.template) || el.dataset.template || '';
            putSplit(el, fillTemplate(tpl, radio));
          });
        }
        renderRows();
      };
      this.radios.forEach(r => on(r, 'change', () => { if (this.error) { this.error.hidden = true; } this.updateOffer(); }));

      /* Leiste: die Angebote als Umschalter, gebaut aus den Radios (ein Zustand, zwei Anzeigen). */
      const segWrap = this.querySelector('[data-sticky-segs]');
      if (segWrap && this.radios.length > 1) {
        this.segs = this.radios.map(radio => {
          const seg = document.createElement('button');
          seg.type = 'button';
          seg.className = 'acg-seg';
          seg.dataset.value = radio.value;
          seg.textContent = radio.dataset.name || '';
          seg.disabled = radio.disabled;
          on(seg, 'click', () => {
            if (radio.disabled || radio.checked) return;
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          });
          return seg;
        });
        segWrap.replaceChildren(...this.segs);
      }


      /* ---------- Steinfenster wie im Kit ----------
         Hängt an <body>; beim Entfernen der Section kommt es an seinen Platz zurück
         (disconnectedCallback). Gewählt wird in einem Entwurf: Reiter oben wechseln das Set,
         "Next" führt zum nächsten, erst "Use this selection" übernimmt, X verwirft.
         Das Plus auf einer Kachel öffnet im selben Fenster die Detailansicht des Sets; dort setzt
         "Choose this set" das Set in den aktiven Reiter und führt zurück ins Raster. */
      let draft = null;
      let lastFocus = null;
      let openedFrom = 0;
      const sheetPanel = sheet?.querySelector('[data-acg-sheet-panel]');
      const sheetHead = sheet?.querySelector('[data-acg-sheet-head]');
      const sheetBody = sheet?.querySelector('[data-acg-sheet-body]');
      const slotsWrap = sheet?.querySelector('[data-acg-sheet-slots]');
      const slotTabs = sheet ? [...sheet.querySelectorAll('[data-acg-sheet-slot]')] : [];
      const sheetGo = sheet?.querySelector('[data-acg-sheet-go]');
      /* Detailansicht: eine Fläche pro Set, gezeigt wird immer nur eine.
         detail = { name, pane, index, scroll, trigger }, solange sie offen ist. */
      const detailWrap = sheet?.querySelector('[data-acg-detail]');
      const detailBack = detailWrap?.querySelector('[data-acg-detail-back]');
      const panes = detailWrap ? [...detailWrap.querySelectorAll('[data-acg-dpane]')] : [];
      let detail = null;
      if (sheet) {
        document.querySelectorAll('[data-acg-sheet-for]').forEach(old => { if (old !== sheet && old.dataset.acgSheetFor === sheet.dataset.acgSheetFor) old.remove(); });
        document.body.appendChild(sheet);
      }
      const renderSheet = () => {
        if (!draft) return;
        const cap = this.cap;
        const multi = cap > 1;
        if (slotsWrap) { slotsWrap.hidden = !multi; slotsWrap.style.setProperty('--acg-slots', String(cap)); slotsWrap.dataset.count = String(cap); }
        if (sheetHead) sheetHead.classList.toggle('is-single', !multi);
        slotTabs.forEach((tab, i) => {
          tab.hidden = i >= cap;
          const set = setByName(draft.picks[i]);
          const isOn = i === draft.slot;
          tab.classList.toggle('is-on', isOn);
          tab.setAttribute('aria-pressed', String(isOn));
          const thumb = tab.querySelector('[data-acg-slot-thumb]');
          const name = tab.querySelector('[data-acg-slot-name]');
          if (thumb && thumb.dataset.name !== (set?.name || '')) { thumb.innerHTML = swatchHtml(set, 72); thumb.dataset.name = set?.name || ''; }
          if (name) name.textContent = set ? set.name : '';
        });
        const cur = draft.picks[draft.slot];
        const used = draft.picks.slice(0, cap);
        SETS.forEach(set => {
          const inSets = [];
          used.forEach((name, i) => { if (name === set.name) inSets.push(i + 1); });
          const isOn = cur === set.name;
          set.el.classList.toggle('is-on', isOn);
          set.pick?.setAttribute('aria-pressed', String(isOn));
          const mark = set.el.querySelector('[data-acg-stone-mark]');
          if (!mark) return;
          if (multi && inSets.length) {
            mark.hidden = false;
            mark.textContent = inSets.join('+');
            mark.classList.toggle('is-other', !isOn);
          } else if (!multi && isOn) {
            mark.hidden = false;
            mark.textContent = '✓';
            mark.classList.remove('is-other');
          } else {
            mark.hidden = true;
          }
        });
        /* Knopf unten:
           · Detailansicht offen: "Choose this set" setzt das Set in den aktiven Reiter; ist es dort
             schon gewählt, steht "Selected". Ein ausverkauftes Set sperrt den Knopf ("Sold out").
           · Sonst Duo/Trio: Set 1 führt über einen sichtbaren Knopf zu Set 2 usw. – nichts springt
             von selbst; danach "Use this selection". */
        if (sheetGo) {
          const goLabel = sheetGo.querySelector('[data-acg-go-label]');
          const iconNext = sheetGo.querySelector('[data-acg-go-next]');
          const iconUse = sheetGo.querySelector('[data-acg-go-use]');
          let action;
          let label;
          if (detail) {
            const open = Boolean(setByName(detail.name)?.available);
            action = open ? 'choose' : 'none';
            label = !open ? sheetGo.dataset.lSold : cur === detail.name ? sheetGo.dataset.lSelected : sheetGo.dataset.lChoose;
          } else {
            action = multi && draft.slot < cap - 1 ? 'next' : 'use';
            label = action === 'next' ? sheetGo.dataset.lNext : sheetGo.dataset.lUse;
          }
          sheetGo.dataset.action = action;
          sheetGo.disabled = action === 'none';
          if (goLabel) goLabel.textContent = label || '';
          if (iconNext) iconNext.hidden = action !== 'next';
          if (iconUse) iconUse.hidden = action === 'next' || action === 'none';
        }
      };
      /* Kachel sichtbar machen, ohne dass sie unter der klebenden Gruppen-Überschrift landet. */
      const revealStone = el => {
        if (!el || !sheetBody || sheetBody.hidden) return;
        const box = sheetBody.getBoundingClientRect();
        const r = el.getBoundingClientRect();
        if (r.top < box.top + 96) sheetBody.scrollTop += r.top - box.top - 96;
        else if (r.bottom > box.bottom - 12) sheetBody.scrollTop += r.bottom - box.bottom + 12;
      };
      /* Fokus auf den Wähl-Knopf der gewählten Kachel (die Kachel selbst ist nur ein Rahmen). */
      const focusCurrentStone = () => {
        const cur = sheet?.querySelector('[data-acg-stone].is-on');
        revealStone(cur);
        cur?.querySelector('[data-acg-stone-pick]')?.focus({ preventScroll: true });
      };
      const popStone = el => {
        el.classList.remove('is-pop');
        void el.offsetWidth;
        el.classList.add('is-pop');
      };

      /* ---------- Detailansicht ----------
         Streifen zum Wischen (Scroll-Snap), Pfeile, Zähler, Vorschaubilder. Der Hinweis zum
         Beispielring steht nur auf der 3D-Folie. */
      const paneSlides = pane => [...pane.querySelectorAll('[data-acg-dslide]')];
      const markDetail = i => {
        if (!detail) return;
        const pane = detail.pane;
        const slides = paneSlides(pane);
        detail.index = i;
        pane.querySelectorAll('[data-acg-dthumb]').forEach(thumb => thumb.setAttribute('aria-current', String(Number(thumb.dataset.acgDthumb) === i)));
        const count = pane.querySelector('[data-acg-dcount]');
        if (count) count.textContent = (i + 1) + ' / ' + slides.length;
        const prev = pane.querySelector('[data-acg-dprev]');
        const next = pane.querySelector('[data-acg-dnext]');
        const active = document.activeElement;
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === slides.length - 1;
        /* Ein gesperrter Pfeil verliert den Fokus: dann bekommt ihn der Streifen (Pfeiltasten gehen weiter). */
        if ((active === prev && prev.disabled) || (active === next && next.disabled)) pane.querySelector('[data-acg-dtrack]')?.focus({ preventScroll: true });
        const note = pane.querySelector('[data-acg-dnote]');
        if (note) note.hidden = !slides[i]?.hasAttribute('data-acg-d3d');
      };
      const goDetail = (i, instant) => {
        if (!detail) return;
        const track = detail.pane.querySelector('[data-acg-dtrack]');
        const slides = paneSlides(detail.pane);
        if (!track || !slides.length) return;
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: i * track.clientWidth, behavior: instant || reduceMotion.matches ? 'auto' : 'smooth' });
        markDetail(i);
      };
      const openDetail = (name, trigger) => {
        if (!detailWrap || !sheetBody) return;
        const pane = panes.find(p => p.dataset.setName === name);
        if (!pane) return;
        detail = { name, pane, index: 0, scroll: sheetBody.scrollTop, trigger: trigger || null };
        panes.forEach(p => { p.hidden = p !== pane; });
        sheetBody.hidden = true;
        detailWrap.hidden = false;
        detailWrap.scrollTop = 0;
        goDetail(0, true);
        renderSheet();
        detailBack?.focus({ preventScroll: true });
      };
      /* refocus = false, wenn danach etwas anderes den Fokus bekommt oder das Fenster zugeht. */
      const closeDetail = refocus => {
        if (!detail) return;
        const d = detail;
        detail = null;
        if (detailWrap) detailWrap.hidden = true;
        if (sheetBody) {
          sheetBody.hidden = false;
          sheetBody.scrollTop = d.scroll;
        }
        renderSheet();
        if (refocus !== false && d.trigger?.isConnected) d.trigger.focus({ preventScroll: true });
      };
      /* Wischen im Streifen: Vorschaubilder, Zähler und Pfeile folgen der Position. */
      panes.forEach(pane => {
        const track = pane.querySelector('[data-acg-dtrack]');
        if (!track) return;
        let ticking = false;
        on(track, 'scroll', () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            ticking = false;
            if (!detail || detail.pane !== pane) return;
            const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
            if (i !== detail.index) markDetail(i);
          });
        }, { passive: true });
      });

      /* trigger = der angetippte Knopf. Safari fokussiert Buttons beim Antippen nicht, deshalb
         kommt der Fokus beim Schließen über ihn zurück, nicht über activeElement. */
      const openSheet = (slot, trigger) => {
        if (!sheet || !sheetPanel || !SETS.length) return;
        clearTimeout(this.sheetHide);
        lastFocus = trigger || document.activeElement;
        openedFrom = Math.max(0, Math.min(Number(slot) || 0, this.cap - 1));
        draft = { picks: this.picks.slice(), slot: openedFrom, gallery: galleryAt() };
        /* Das Fenster öffnet immer im Raster, nie in einer alten Detailansicht. */
        detail = null;
        if (detailWrap) detailWrap.hidden = true;
        if (sheetBody) sheetBody.hidden = false;
        renderSheet();
        sheet.hidden = false;
        document.documentElement.classList.add('acg-locked');
        if (sheetBody) sheetBody.scrollTop = 0;
        void sheetPanel.offsetWidth; /* Startlage festschreiben, sonst fährt das Fenster nicht ein */
        sheet.classList.add('is-open');
        focusCurrentStone();
      };
      const closeSheet = commit => {
        if (!sheet || sheet.hidden) return;
        closeDetail(false);
        const chosen = draft;
        draft = null;
        sheet.classList.remove('is-open');
        document.documentElement.classList.remove('acg-locked');
        clearTimeout(this.sheetHide);
        this.sheetHide = setTimeout(() => { sheet.hidden = true; }, reduceMotion.matches ? 0 : 420);
        if (commit && chosen) {
          this.picks = chosen.picks.slice();
          this.updateOffer();
          /* Galerie bleibt beim Bild des zuletzt bearbeiteten Sets. */
          showStone(this.picks[chosen.slot], true);
        } else if (chosen) {
          /* Verworfen: die Galerie zeigt wieder, was sie vor dem Öffnen gezeigt hat. */
          galleryGo(chosen.gallery, true);
        }
        const back = lastFocus && lastFocus !== document.body && document.contains(lastFocus) ? lastFocus : rows[openedFrom] || rows[0];
        back?.focus?.({ preventScroll: true });
      };
      this.querySelectorAll('[data-acg-st-open]').forEach(btn => on(btn, 'click', () => openSheet(btn.dataset.acgStOpen, btn)));
      /* Reihenfolge: schließen → Plus → zurück → Pfeile → Vorschaubild → Wähl-Knopf → Reiter → Knopf unten. */
      on(sheet, 'click', e => {
        if (e.target.closest('[data-acg-sheet-close]')) { closeSheet(false); return; }
        if (!draft) return;
        /* Plus auf der Kachel: Details öffnen, ohne das Set zu wählen. */
        const detailButton = e.target.closest('[data-acg-stone-detail]');
        if (detailButton) {
          const tile = detailButton.closest('[data-acg-stone]');
          if (tile) openDetail(tile.dataset.setName, detailButton);
          return;
        }
        if (e.target.closest('[data-acg-detail-back]')) { closeDetail(); return; }
        if (e.target.closest('[data-acg-dprev]')) { goDetail(detail ? detail.index - 1 : 0); return; }
        if (e.target.closest('[data-acg-dnext]')) { goDetail(detail ? detail.index + 1 : 0); return; }
        const dthumb = e.target.closest('[data-acg-dthumb]');
        if (dthumb) { goDetail(Number(dthumb.dataset.acgDthumb) || 0); return; }
        const pick = e.target.closest('[data-acg-stone-pick]');
        if (pick) {
          const stone = pick.closest('[data-acg-stone]');
          if (!stone || pick.disabled) return;
          draft.picks[draft.slot] = stone.dataset.setName;
          popStone(stone);
          renderSheet();
          /* Angeklickter Stein = sein Bild in der Galerie. */
          showStone(stone.dataset.setName, true);
          return;
        }
        const tab = e.target.closest('[data-acg-sheet-slot]');
        if (tab) {
          draft.slot = Number(tab.dataset.acgSheetSlot) || 0;
          renderSheet();
          if (!detail) revealStone(sheet.querySelector('[data-acg-stone].is-on'));
          showStone(draft.picks[draft.slot], true);
          return;
        }
        if (e.target.closest('[data-acg-sheet-go]')) {
          const action = sheetGo?.dataset.action;
          if (action === 'choose' && detail) {
            /* Set in den aktiven Reiter, zurück ins Raster an seine Kachel. Kein Sprung zu Set 2. */
            const name = detail.name;
            draft.picks[draft.slot] = name;
            closeDetail(false);
            const chosen = setByName(name);
            if (chosen) popStone(chosen.el);
            focusCurrentStone();
            showStone(name, true);
          } else if (action === 'next') {
            draft.slot += 1;
            renderSheet();
            focusCurrentStone();
            showStone(draft.picks[draft.slot], true);
          } else if (action === 'use') {
            closeSheet(true);
          }
        }
      });
      /* Escape: aus der Detailansicht zurück ins Raster, sonst schließen ohne zu übernehmen.
         Pfeiltasten blättern in der Detailansicht. Tab bleibt im Fenster. Die Listener am
         document prüfen zuerst, ob ihr Fenster noch im Dokument steckt (Theme-Editor rendert neu). */
      on(document, 'keydown', e => {
        if (!sheet || !sheet.isConnected || sheet.hidden || !draft) return;
        if (e.key === 'Escape') {
          e.preventDefault();
          if (detail) closeDetail(); else closeSheet(false);
          return;
        }
        if (detail && (e.key === 'ArrowLeft' || e.key === 'ArrowRight')) {
          e.preventDefault();
          goDetail(detail.index + (e.key === 'ArrowRight' ? 1 : -1));
          return;
        }
        if (e.key !== 'Tab') return;
        const items = [...sheetPanel.querySelectorAll('button, [tabindex="0"]')].filter(el => !el.disabled && el.getClientRects().length > 0);
        if (!items.length) return;
        const firstItem = items[0];
        const lastItem = items[items.length - 1];
        if (!sheetPanel.contains(document.activeElement)) { e.preventDefault(); firstItem.focus(); return; }
        if (e.shiftKey && document.activeElement === firstItem) { e.preventDefault(); lastItem.focus(); }
        else if (!e.shiftKey && document.activeElement === lastItem) { e.preventDefault(); firstItem.focus(); }
      });
      /* Theme-Editor: einen Steinset-Block anklicken öffnet das Fenster an dieser Kachel.
         Ist dabei eine Detailansicht offen, geht es zurück ins Raster. */
      on(document, 'shopify:block:select', e => {
        if (!sheet || !sheet.isConnected || !sheet.contains(e.target)) return;
        if (sheet.hidden || !draft) openSheet(0);
        closeDetail(false);
        revealStone(e.target);
      });
      on(document, 'shopify:block:deselect', e => { if (sheet && sheet.isConnected && sheet.contains(e.target)) closeSheet(false); });

      this.updateOffer();

      /* Sterne: springen zu den Bewertungen dieser Section, sonst zum eingestellten Ziel. */
      const ratingLink = this.querySelector('[data-reviews-link]');
      on(ratingLink, 'click', event => {
        if (!(ratingLink.getAttribute('href') || '').startsWith('#')) return;
        let target = this.querySelector('[data-acg-reviews]');
        const key = (ratingLink.dataset.target || '').trim();
        if (!target && key) {
          target = document.getElementById(key.replace(/^#/, ''));
          if (!target) target = [...document.querySelectorAll('[id]')].find(el => el.id.endsWith('__' + key));
          if (!target) { try { target = document.querySelector(key); } catch {} }
        }
        if (!target) target = document.getElementById(ratingLink.hash.slice(1));
        if (!target) target = document.querySelector('.aty-reviews, #judgeme_product_reviews, #looxReviews');
        if (!target) return;
        event.preventDefault();
        const offset = parseFloat(getComputedStyle(this).getPropertyValue('--sticky-top')) || 24;
        window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - offset, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
        const hadTabindex = target.hasAttribute('tabindex');
        if (!hadTabindex) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
        if (!hadTabindex) target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
      });

      /* Ersatzweg, falls kein anderes Script das Formular übernimmt (der Warenkorb in der
         Kopfzeile fängt es sonst vorher ab und schickt die Felder selbst). */
      on(this.form, 'submit', async event => {
        if (event.submitter && !event.submitter.matches('[data-main-buy],[data-sticky-buy]')) return;
        event.preventDefault();
        if (this.pending) return;
        const radio = this.radios.find(r => r.checked && !r.disabled);
        if (!radio) { if (this.error) { this.error.textContent = this.dataset.selectError; this.error.hidden = false; } return; }
        this.pending = true;
        if (this.error) this.error.hidden = true;
        this.updateOffer();
        const properties = {};
        this.picks.slice(0, this.cap).forEach((name, i) => { if (name) properties[propBase + ' ' + (i + 1)] = name; });
        const items = [{ id: radio.value, quantity: 1, properties }];
        try {
          const response = await fetch(this.dataset.addUrl, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
          const data = await response.json();
          if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : this.dataset.error);
          window.location.assign(this.dataset.cartUrl);
        } catch (error) {
          if (!this.isConnected) return;
          if (this.error) { this.error.textContent = error.message || this.dataset.error; this.error.hidden = false; }
          this.pending = false;
          this.updateOffer();
        }
      });

      /* Galerie wie im Kit: ein Streifen für alle Medien. Handy wischt, Desktop steuert ihn
         über die Vorschaubilder; Punkte und Vorschaubilder stehen in derselben Reihenfolge. */
      const track = this.querySelector('[data-gal-track]');
      const slides = [...this.querySelectorAll('[data-slide]')];
      const thumbs = [...this.querySelectorAll('[data-thumb]')];
      const dots = [...this.querySelectorAll('[data-gal-dot]')];
      const view3dBtn = this.querySelector('[data-view3d]');
      let index = 0;
      const pauseSlide = slide => {
        slide.querySelectorAll('video').forEach(video => video.pause());
        slide.querySelectorAll('iframe').forEach(frame => {
          try {
            const origin = new URL(frame.src, location.href).origin;
            if (/youtube/.test(origin)) frame.contentWindow?.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), origin);
            if (/vimeo/.test(origin)) frame.contentWindow?.postMessage(JSON.stringify({ method: 'pause' }), origin);
          } catch {}
        });
      };
      const markSlide = i => {
        index = i;
        thumbs.forEach((thumb, n) => { thumb.classList.toggle('is-on', n === i); thumb.setAttribute('aria-pressed', String(n === i)); });
        dots.forEach((dot, n) => { dot.classList.toggle('is-on', n === i); if (n === i) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
        slides.forEach((slide, n) => { if (n !== i) pauseSlide(slide); });
        if (view3dBtn) view3dBtn.classList.toggle('is-active', slides[i]?.dataset.mediaType === 'model');
      };
      const goSlide = (i, instant) => {
        if (!track || !slides.length) return;
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: i * track.clientWidth, behavior: instant || reduceMotion.matches ? 'auto' : 'smooth' });
        markSlide(i);
      };
      if (track) {
        let ticking = false;
        on(track, 'scroll', () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            ticking = false;
            const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
            if (i !== index) markSlide(i);
          });
        }, { passive: true });
        on(track, 'keydown', e => {
          if (e.target !== track) return;
          if (e.key === 'ArrowRight') { e.preventDefault(); goSlide(index + 1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); goSlide(index - 1); }
        });
        /* Nach dem Drehen oder Verkleinern bleibt dasselbe Bild stehen. */
        on(window, 'resize', () => goSlide(index, true));
      }
      thumbs.forEach((thumb, i) => on(thumb, 'click', () => goSlide(i)));
      dots.forEach((dot, i) => on(dot, 'click', () => goSlide(i)));
      if (view3dBtn) on(view3dBtn, 'click', () => { const t = parseInt(view3dBtn.dataset.target || '0', 10); goSlide(isNaN(t) ? 0 : t); });
      /* Regel Stein → Bild, ohne Zuordnung von Hand: zuerst die Dateien des Steins ("Galeriebild",
         dann sein Foto), sonst ein Bild, dessen Alt-Text dem Steinnamen entspricht. Kein Treffer:
         die Galerie bleibt, wo sie ist. */
      const slideOf = set => {
        if (!set) return -1;
        for (const file of set.files) {
          const i = slides.findIndex(slide => slide.dataset.file === file);
          if (i >= 0) return i;
        }
        const name = set.name.trim().toLowerCase();
        return slides.findIndex(slide => (slide.dataset.alt || '').trim().toLowerCase() === name);
      };
      showStone = (name, instant) => {
        const i = slideOf(setByName(name));
        if (i >= 0 && i !== index) goSlide(i, instant);
      };
      galleryAt = () => index;
      galleryGo = (i, instant) => { if (typeof i === 'number' && i !== index) goSlide(i, instant); };

      const dialog = this.querySelector('dialog');
      const zoomContent = this.querySelector('[data-zoom-content]');
      const openZoom = btn => {
        const image = btn.querySelector('img');
        if (!image || !dialog || typeof dialog.showModal !== 'function') return;
        const clone = image.cloneNode(true);
        clone.removeAttribute('loading');
        clone.removeAttribute('sizes');
        clone.removeAttribute('srcset');
        clone.removeAttribute('fetchpriority');
        zoomContent.replaceChildren(clone);
        dialog.showModal();
      };
      this.querySelectorAll('.image-open').forEach(btn => on(btn, 'click', () => openZoom(btn)));
      on(this.querySelector('[data-close]'), 'click', () => dialog.close());
      on(dialog, 'click', e => { if (e.target === dialog) dialog.close(); });

      /* FAQ im Hallmark-Muster: die Antwortfläche (.acg-panel) fährt in Höhe und Deckkraft auf und
         zu (460 ms auf, 340 ms zu), das Plus dreht dabei zum ×. Bei „weniger Bewegung“ oder ohne
         WAAPI klappt der Browser das <details> nativ um, nur ohne Bewegung. */
      this.querySelectorAll('details.acg-q').forEach(item => {
        const summary = item.querySelector('summary');
        const panel = item.querySelector('.acg-panel');
        if (!summary || !panel || typeof panel.animate !== 'function') return;
        let run = null;
        on(summary, 'click', event => {
          /* „Weniger Bewegung“ wird bei jedem Klick geprüft: dann schaltet der Browser nativ um. */
          if (reduceMotion.matches) return;
          event.preventDefault();
          if (run) { run.cancel(); run = null; }
          if (!item.open || item.classList.contains('is-closing')) {
            item.classList.remove('is-closing');
            item.open = true;
            run = panel.animate(
              [{ height: '0px', opacity: 0 }, { height: panel.offsetHeight + 'px', opacity: 1 }],
              { duration: 460, easing: 'cubic-bezier(.22, 1, .36, 1)' }
            );
            run.onfinish = () => { run = null; };
          } else {
            item.classList.add('is-closing');
            run = panel.animate(
              [{ height: panel.offsetHeight + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
              { duration: 340, easing: 'cubic-bezier(.4, 0, .2, 1)' }
            );
            run.onfinish = () => { run = null; item.open = false; item.classList.remove('is-closing'); };
          }
        });
        this.lifecycle.signal.addEventListener('abort', () => { if (run) run.cancel(); }, { once: true });
      });

      if (this.mainBuy && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(([entry]) => { const st = this.querySelector('[data-sticky]'); if (st) st.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0; });
        this.observer.observe(this.mainBuy);
      }

      /* Lieferdatum: heute + N Werktage (bei einer Spanne der späteste Tag), im Format der
         Shop-Sprache, z. B. "Thu, Oct 1". Liquid hat es schon vorgeschrieben. */
      const elDelivery = this.querySelector('[data-delivery]');
      if (elDelivery) {
        const addWorkdays = n => {
          const d = new Date();
          let added = 0;
          while (added < n) {
            d.setDate(d.getDate() + 1);
            if (d.getDay() !== 0 && d.getDay() !== 6) added += 1;
          }
          return d;
        };
        const daysMin = parseInt(this.dataset.leadDays || '1', 10) || 1;
        const daysMax = parseInt(this.dataset.leadDaysMax || '0', 10) || 0;
        try {
          elDelivery.textContent = addWorkdays(Math.max(daysMin, daysMax)).toLocaleDateString(this.dataset.locale || 'en', { weekday: 'short', day: 'numeric', month: 'short' });
        } catch {}
      }

      /* Galerie klebt unter der Navigation: Versatz aus deren echter Höhe (wie im Kit),
         mindestens der Wert aus der Einstellung "Abstand Galerie oben". */
      const nav = document.querySelector('.aty-nav--solid');
      if (nav) {
        const base = parseFloat(getComputedStyle(this).getPropertyValue('--sticky-top')) || 0;
        const setStickyTop = () => this.style.setProperty('--sticky-top', Math.max(base, nav.offsetHeight + 20) + 'px');
        setStickyTop();
        on(window, 'resize', setStickyTop);
      }

      /* Schritt-Videos: stumm in Schleife, nur solange sie im Bild sind. Bei "weniger
         Bewegung" bleibt das Standbild stehen und man startet selbst. */
      const videos = [...this.querySelectorAll('[data-acg-video]')];
      if (videos.length) {
        const play = video => { const promise = video.play(); if (promise && typeof promise.catch === 'function') promise.catch(() => {}); };
        videos.forEach(video => { video.muted = true; });
        if (reduceMotion.matches) {
          videos.forEach(video => { video.controls = true; video.preload = 'metadata'; });
        } else if ('IntersectionObserver' in window) {
          this.videoObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => { if (entry.isIntersecting) play(entry.target); else entry.target.pause(); });
          }, { rootMargin: '120px 0px', threshold: 0.2 });
          videos.forEach(video => this.videoObserver.observe(video));
        } else {
          videos.forEach(play);
        }
      }

      /* Vorher/Nachher wie im Kit: Ziehen mit Maus oder Finger, Pfeiltasten am Griff (Shift =
         größere Schritte, Pos1/Ende = Anschlag). touch-action: pan-y lässt senkrechtes Wischen
         die Seite scrollen. Beim ersten Sichtkontakt schwenkt der Griff einmal kurz, damit man
         sieht, dass man ziehen kann (nicht bei "weniger Bewegung", nicht nach eigenem Anfassen). */
      this.compareObservers = [];
      this.querySelectorAll('[data-acg-compare]').forEach(stage => {
        const handle = stage.querySelector('[data-acg-compare-handle]');
        const labelB = stage.dataset.labelBefore || '';
        const labelA = stage.dataset.labelAfter || '';
        let pos = 50;
        let dragging = false;
        let touched = false;
        let hintRaf = 0;
        const clamp01 = v => (v < 0 ? 0 : v > 1 ? 1 : v);
        const setPos = p => {
          pos = p < 0 ? 0 : p > 100 ? 100 : p;
          stage.style.setProperty('--pos', pos + '%');
          if (handle) {
            handle.setAttribute('aria-valuenow', Math.round(pos));
            handle.setAttribute('aria-valuetext', Math.round(pos) + '% ' + labelB + ', ' + Math.round(100 - pos) + '% ' + labelA);
          }
        };
        const fromEvent = e => {
          const r = stage.getBoundingClientRect();
          if (r.width) setPos((e.clientX - r.left) / r.width * 100);
        };
        const stopHint = () => {
          touched = true;
          if (hintRaf) cancelAnimationFrame(hintRaf);
          hintRaf = 0;
        };
        this.lifecycle.signal.addEventListener('abort', stopHint, { once: true });
        on(stage, 'pointerdown', e => {
          if (e.button !== undefined && e.button !== 0) return;
          stopHint();
          dragging = true;
          stage.classList.add('is-drag');
          try { stage.setPointerCapture(e.pointerId); } catch {}
          fromEvent(e);
          if (e.pointerType === 'mouse' && handle) { e.preventDefault(); handle.focus({ preventScroll: true }); }
        });
        on(stage, 'pointermove', e => { if (dragging) fromEvent(e); });
        ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(type => on(stage, type, () => { dragging = false; stage.classList.remove('is-drag'); }));
        on(handle, 'keydown', e => {
          const step = e.shiftKey ? 10 : 4;
          let next = null;
          if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') next = pos - step;
          if (e.key === 'ArrowRight' || e.key === 'ArrowUp') next = pos + step;
          if (e.key === 'Home') next = 0;
          if (e.key === 'End') next = 100;
          if (next === null) return;
          e.preventDefault();
          stopHint();
          setPos(next);
        });
        const hint = () => {
          if (touched || reduceMotion.matches) return;
          const keys = [[0, 50], [520, 30], [1180, 70], [1650, 50]];
          const ease = t => (t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2);
          let t0 = null;
          const tick = now => {
            if (touched) return;
            if (t0 === null) t0 = now;
            const t = now - t0;
            let i = 1;
            while (i < keys.length - 1 && t > keys[i][0]) i++;
            const a = keys[i - 1];
            const b = keys[i];
            setPos(a[1] + (b[1] - a[1]) * ease(clamp01((t - a[0]) / (b[0] - a[0]))));
            if (t < keys[keys.length - 1][0]) hintRaf = requestAnimationFrame(tick);
            else { setPos(50); hintRaf = 0; }
          };
          hintRaf = requestAnimationFrame(tick);
        };
        setPos(50);
        if ('IntersectionObserver' in window) {
          const seen = new IntersectionObserver(entries => {
            if (!entries[0].isIntersecting) return;
            seen.disconnect();
            setTimeout(hint, 350);
          }, { threshold: 0.55 });
          seen.observe(stage);
          this.compareObservers.push(seen);
        }
      });

      /* Bewertungs-Laufband im Theme-Editor: eine angeklickte Bewertung bleibt stehen und
         rückt ins Bild, beim Abwählen läuft das Band weiter. Im Shop ohne Wirkung. */
      const rvList = this.querySelector('[data-acg-marquee]');
      const rvTrack = rvList?.querySelector('.acg-reviews-track');
      if (rvList && rvTrack) {
        on(document, 'shopify:block:select', e => {
          if (!rvList.contains(e.target)) return;
          rvTrack.style.animation = 'none';
          rvList.scrollLeft = 0;
          rvList.scrollLeft = Math.max(0, e.target.getBoundingClientRect().left - rvList.getBoundingClientRect().left - 24);
        });
        on(document, 'shopify:block:deselect', e => {
          if (!rvList.contains(e.target)) return;
          rvTrack.style.animation = '';
          rvList.scrollLeft = 0;
        });
      }
    }
    disconnectedCallback() {
      this.lifecycle?.abort();
      this.observer?.disconnect();
      this.videoObserver?.disconnect();
      this.compareObservers?.forEach(observer => observer.disconnect());
      this.querySelector('dialog')?.close();
      /* Steinfenster zurück an seinen Platz: geht die Section weg, geht es mit; wird sie nur
         verschoben, findet das nächste connectedCallback es wieder. */
      clearTimeout(this.sheetHide);
      document.documentElement.classList.remove('acg-locked');
      if (this.sheet) {
        this.sheet.classList.remove('is-open');
        this.sheet.hidden = true;
        if (this.sheetHome && this.sheetHome !== this.sheet.parentNode) this.sheetHome.appendChild(this.sheet);
      }
      this.initialized = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelaye-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Starter Kit / Duo: wählt wie auf der Kit-Seite; der Button führt dann mit dieser Variante zur Kit-Seite. */
  function initTiles(root) {
    root.querySelectorAll('[data-atc3-choose]').forEach(function (box) {
      if (box.getAttribute('data-ready')) { return; }
      box.setAttribute('data-ready', '1');
      var card = box.closest('.atc3__hero');
      var cta = card ? card.querySelector('[data-atc3-cta]') : null;
      var tiles = Array.prototype.slice.call(box.querySelectorAll('[data-atc3-tile]'));
      function usable(t) { return t.getAttribute('data-unavailable') !== 'true'; }
      function pick(t, focus) {
        if (!usable(t)) { return; }
        tiles.forEach(function (x) {
          x.setAttribute('aria-checked', x === t ? 'true' : 'false');
          x.tabIndex = x === t ? 0 : -1;
        });
        if (cta && t.getAttribute('data-url')) { cta.setAttribute('href', t.getAttribute('data-url')); }
        if (focus) { t.focus(); }
      }
      tiles.forEach(function (t, i) {
        t.addEventListener('click', function () { pick(t); });
        t.addEventListener('keydown', function (e) {
          var d = (e.key === 'ArrowDown' || e.key === 'ArrowRight') ? 1 : (e.key === 'ArrowUp' || e.key === 'ArrowLeft') ? -1 : 0;
          if (!d) { return; }
          e.preventDefault();
          for (var k = 1; k < tiles.length; k++) {
            var n = tiles[(i + d * k + tiles.length * k) % tiles.length];
            if (usable(n)) { pick(n, true); break; }
          }
        });
      });
    });
  }
  /* How it works: läuft einmal ab, sobald der Block gut zur Hälfte im Bild ist (wie die Rewards-Seite ohne Scrollweg). */
  function initHow(root) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) { return; }
    root.querySelectorAll('[data-atc3-how]').forEach(function (how) {
      if (how.getAttribute('data-ready')) { return; }
      how.setAttribute('data-ready', '1');
      var steps = how.querySelectorAll('[data-atc3-step]');
      if (!steps.length) { return; }
      how.classList.add('is-anim');
      var io = new IntersectionObserver(function (entries) {
        if (!entries.some(function (en) { return en.isIntersecting; })) { return; }
        io.disconnect();
        how.classList.add('is-auto');
        Array.prototype.forEach.call(steps, function (st) { st.style.setProperty('--seg', '1'); st.classList.add('is-on'); });
      }, { rootMargin: '0px 0px -45% 0px' });
      io.observe(how);
    });
  }
  function init(root) { initTiles(root); initHow(root); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelaye-contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Hallmark: die Haarlinie über dem Direktkontakt zieht sich einmal, sobald sie halb im Bild ist.
       Ohne JS oder bei reduzierter Bewegung steht sofort der Endzustand. */
    function init(scope) {
      var hosts = scope.classList && scope.classList.contains('aty-contact') ? [scope] : scope.querySelectorAll('.aty-contact');
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      Array.prototype.forEach.call(hosts, function (host) {
        if (host.getAttribute('data-ac-ready')) { return; }
        host.setAttribute('data-ac-ready', '1');
        if (reduce || !('IntersectionObserver' in window)) { return; }
        var items = host.querySelectorAll('[data-ac-reveal]');
        if (!items.length) { return; }
        host.classList.add('is-anim');
        Array.prototype.forEach.call(items, function (el) {
          var io = new IntersectionObserver(function (entries) {
            if (!entries.some(function (en) { return en.isIntersecting; })) { return; }
            io.disconnect();
            el.classList.add('is-on');
          }, { rootMargin: '0px 0px -35% 0px' });
          io.observe(el);
        });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelaye-gemstones"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('atelaye-gemstones')) {
  customElements.define('atelaye-gemstones', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.classList.add('atg-enhanced');
      this.lifecycle = new AbortController();
      const on = (node, event, fn, opts) => node?.addEventListener(event, fn, { signal: this.lifecycle.signal, ...(opts||{}) });
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.radios = [...this.querySelectorAll('[data-offer]')];
      this.form = this.querySelector('.atg-form');
      this.mainBuy = this.querySelector('[data-main-buy]');
      this.stickyBuy = this.querySelector('[data-sticky-buy]');
      this.error = this.querySelector('[data-error-message]');
      this.pending = false;
      const first = this.radios.find(r => !r.disabled);
      if (first && !this.radios.some(r => r.checked && !r.disabled)) first.checked = true;
      /* Galerie-Anbindung, wird unten bei der Galerie belegt: Stein zeigen, Position lesen/setzen. */
      let showStone = () => {};
      let galleryAt = () => 0;
      let galleryGo = () => {};

      const esc = value => String(value == null ? '' : value).replace(/[&<>"']/g, ch => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]));

      /* Geld so, wie Shopify es schreibt: Muster aus dem money-Filter für 1234,56 (z. B. "€1,234.56"),
         daraus Zeichen vor und nach der Zahl, Tausender- und Dezimaltrenner. Gilt auch für
         andere Währungen der Markets, weil Liquid das Muster in der Besucherwährung liefert. */
      const moneySample = this.dataset.moneySample || '';
      const moneyMatch = moneySample.match(/\d[\d.,'\s  ]*\d/);
      const formatMoney = cents => {
        cents = Math.round(Number(cents) || 0);
        if (!moneyMatch) return (cents / 100).toFixed(2);
        const num = moneyMatch[0];
        const dec = /[.,]\d{2}$/.test(num) ? num.charAt(num.length - 3) : '';
        const intPart = dec ? num.slice(0, -3) : num;
        const thou = intPart.replace(/\d/g, '').charAt(0);
        const whole = String(Math.floor(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, thou);
        /* Ohne ",00" wie money_without_trailing_zeros: 70 € statt 70,00 €, 13,50 € bleibt. */
        const frac = dec && cents % 100 ? dec + String(cents % 100).padStart(2, '0') : '';
        return moneySample.slice(0, moneyMatch.index) + whole + frac + moneySample.slice(moneyMatch.index + num.length);
      };

      /* Inhaltszeile: " — " teilt in Hauptzeile und kleine Zeile darunter, wie in Liquid. */
      const putSplit = (el, value) => {
        const parts = String(value == null ? '' : value).split(' — ');
        const main = parts.shift();
        const sub = parts.join(' — ');
        el.innerHTML = '<span class="atg-inc-main">' + esc(main) + '</span>' + (sub ? '<small class="atg-inc-sub">' + esc(sub) + '</small>' : '');
      };

      /* ---------- Steine ----------
         Alle Steine stehen als Kacheln im Fenster. Die Wahl (bis zu drei Sets) steckt in den
         Feldern properties[Gemstone set 1/2/3]; Liquid hat sie vorbelegt, das Script übernimmt
         sie von dort. */
      const stones = this.querySelector('[data-atg-stones]');
      const sheet = this.querySelector('[data-atg-sheet]');
      this.sheet = sheet;
      this.sheetHome = sheet?.parentNode || null;
      const SETS = sheet ? [...sheet.querySelectorAll('[data-atg-stone]')].map(el => ({
        name: el.dataset.setName || '',
        kind: el.dataset.kind || 'set',
        meta: el.dataset.meta || '',
        count: el.dataset.count || '',
        stones: parseInt(el.dataset.stones || '0', 10) || (el.dataset.kind === 'set' ? 8 : 1),
        thumb: el.dataset.thumb || '',
        swatch: el.dataset.swatch || '',
        files: (el.dataset.files || '').split(',').map(f => f.trim()).filter(Boolean),
        colours: (el.dataset.colours || '').split(',').map(c => c.trim()).filter(c => /^#?[0-9a-z]{3,8}$/i.test(c)),
        /* Kachel = Rahmen (el) mit Wähl-Knopf (pick) und Plus; ausverkauft = Wähl-Knopf gesperrt. */
        available: !el.querySelector('[data-atg-stone-pick]')?.disabled,
        pick: el.querySelector('[data-atg-stone-pick]') || el,
        el
      })) : [];
      const setByName = name => SETS.find(set => set.name === name);
      /* Ohne Foto zeichnet die Kachel die Steine aus den hinterlegten Farben. */
      const gemSvg = set => {
        const cols = set.colours.length ? set.colours : ['#D2CBBB'];
        let out = '<svg viewBox="0 0 100 100" aria-hidden="true" focusable="false">';
        if (set.kind === 'oval') out += '<ellipse cx="50" cy="50" rx="22" ry="27" fill="' + cols[0] + '"/>';
        else if (set.kind === 'emerald') out += '<path d="M35 25h30l7 7v36l-7 7H35l-7-7V32Z" fill="' + cols[0] + '"/>';
        else [[27, 25], [57, 20], [79, 33], [24, 50], [50, 47], [76, 61], [34, 73], [63, 78]].forEach((pt, i) => { out += '<circle cx="' + pt[0] + '" cy="' + pt[1] + '" r="7" fill="' + cols[i % cols.length] + '"/>'; });
        return out + '</svg>';
      };
      SETS.forEach(set => {
        const box = set.el.querySelector('[data-atg-stone-img]');
        if (box && !box.querySelector('img')) box.insertAdjacentHTML('beforeend', gemSvg(set));
      });
      const thumbHtml = (set, size) => !set ? '' : set.thumb
        ? '<img src="' + esc(set.thumb) + '" alt="" width="' + size + '" height="' + size + '" loading="lazy" decoding="async">'
        : gemSvg(set);
      /* Runder Swatch wie im Kit: eigenes Swatch-Bild, sonst das Foto, sonst die Grafik. */
      const swatchHtml = (set, size) => !set ? '' : (set.swatch || set.thumb)
        ? '<img src="' + esc(set.swatch || set.thumb) + '" alt="" width="' + size + '" height="' + size + '" loading="eager" decoding="async">'
        : gemSvg(set);

      const props = [...this.querySelectorAll('input[data-atg-prop]')].sort((a, b) => Number(a.dataset.atgProp) - Number(b.dataset.atgProp));
      const firstFree = SETS.find(set => set.available && set.kind === 'set') || SETS.find(set => set.available);
      this.picks = props.map(input => {
        const set = setByName(input.value);
        return set && set.available ? set.name : (firstFree ? firstFree.name : '');
      });
      const packOf = radio => Math.max(1, Math.min(3, parseInt(radio?.dataset.pack || '1', 10) || 1));
      this.cap = packOf(this.radios.find(r => r.checked && !r.disabled));

      const L = stones ? stones.dataset : {};
      const propBase = L.propBase || 'Gemstone set';
      const slotLabel = i => (L.lSet || '').replace('__N__', String(i + 1));
      /* Namen der Sets, doppelte zusammengefasst: "Rainbow ×2 · Crystal". */
      const chosenNames = (list, joiner) => {
        const out = [];
        list.forEach(name => {
          if (!name || out.some(item => item.name === name)) return;
          out.push({ name, n: list.filter(other => other === name).length });
        });
        return out.map(item => item.name + (item.n > 1 ? ' ×' + item.n : '')).join(joiner || ' · ');
      };
      const stonesTotal = list => list.reduce((sum, name) => sum + (setByName(name)?.stones || 0), 0);

      /* Karte auf der Seite wie im Kit: ein runder Swatch pro Set (Single links mit Name daneben,
         Duo/Trio nebeneinander), darunter im Link vier noch nicht gewählte Steine als Punkte.
         "Gemstone set 1" und "Change stones" stehen nur im aria-label. Ein gewechselter Stein
         blendet weich ein. */
      const rows = [...this.querySelectorAll('[data-atg-st-row]')];
      const stList = this.querySelector('[data-atg-st-list]');
      const stack = this.querySelector('[data-atg-st-stack]');
      const renderRows = () => {
        if (stList) stList.dataset.n = String(this.cap);
        rows.forEach((row, i) => {
          row.hidden = i >= this.cap;
          const set = setByName(this.picks[i]);
          if (!set) return;
          const thumb = row.querySelector('[data-atg-row-thumb]');
          const name = row.querySelector('[data-atg-row-name]');
          if (thumb && (thumb.dataset.name !== set.name || !thumb.firstElementChild)) {
            const swapped = Boolean(thumb.dataset.name) && thumb.dataset.name !== set.name;
            thumb.innerHTML = swatchHtml(set, 128);
            thumb.dataset.name = set.name;
            if (swapped && !row.hidden && !reduceMotion.matches) {
              row.classList.remove('is-swap');
              void row.offsetWidth;
              row.classList.add('is-swap');
            }
          }
          if (name) name.textContent = set.name;
          row.setAttribute('aria-label', (this.cap > 1 ? slotLabel(i) + ': ' : '') + set.name + '. ' + (L.lChange || ''));
        });
        if (stack) {
          const chosen = this.picks.slice(0, this.cap);
          const others = SETS.filter(set => set.available && chosen.indexOf(set.name) === -1);
          const show = [];
          [1, 3, others.length - 3, others.length - 1].forEach(i => { const set = others[i]; if (set && show.indexOf(set) === -1) show.push(set); });
          const key = show.map(set => set.name).join('|');
          if (stack.dataset.key !== key) {
            stack.innerHTML = show.map(set => '<span class="atg-st-dot">' + swatchHtml(set, 52) + '</span>').join('');
            stack.dataset.key = key;
          }
        }
      };

      /* Silver-Clay-Zusatz: an/aus über "Add". Der Preis steckt danach im Kaufbutton und in der
         Leiste; Shop Pay & Co. verschwinden, solange er gewählt ist (sie kaufen nur die Steine). */
      const addon = this.querySelector('[data-addon]');
      const addonToggle = addon?.querySelector('[data-addon-toggle]');
      const addonLabel = addon?.querySelector('[data-addon-label]');
      const addonCents = () => (addon ? parseInt(addon.dataset.priceCents || '0', 10) || 0 : 0);
      this.addonOn = false;

      /* Gratisversand-Zeile: "ab 159 €", "mit dem Clay gratis" oder "gratis". */
      const ship = this.querySelector('[data-atg-ship]');
      const shipText = ship?.querySelector('[data-atg-ship-text]');
      const updateShip = offerCents => {
        if (!ship || !shipText) return;
        const limit = parseInt(ship.dataset.threshold || '0', 10) || 0;
        if (!limit || !offerCents) { ship.hidden = true; return; }
        const withAddon = offerCents + addonCents();
        let text = ship.dataset.tFrom || '';
        let free = false;
        if (offerCents >= limit || (this.addonOn && withAddon >= limit)) { text = ship.dataset.tFree || ''; free = true; }
        else if (withAddon >= limit) text = ship.dataset.tAdd || '';
        shipText.textContent = text;
        ship.classList.toggle('is-free', free);
        ship.hidden = !text;
      };

      /* Platzhalter der Inhaltszeilen: {count} Sets, {offer} Angebot, {sets} gewählte Steine,
         {stones} Steine gesamt ("1 stone" statt "1 stones"). */
      const fillTemplate = (tpl, radio) => {
        const list = this.picks.slice(0, this.cap);
        const total = stonesTotal(list);
        let out = String(tpl || '');
        if (total === 1) out = out.split('{stones} stones').join('1 stone').split('{stones} Steine').join('1 Stein');
        return out.split('{count}').join(String(this.cap)).split('{stones}').join(String(total)).split('{offer}').join(radio?.dataset.name || '').split('{sets}').join(chosenNames(list));
      };

      this.segs = [];
      this.updateOffer = () => {
        const radio = this.radios.find(r => r.checked && !r.disabled);
        this.cap = packOf(radio);
        const variantInput = this.querySelector('input[data-variant-id]');
        if (variantInput) {
          const nextId = radio?.value || '';
          if (variantInput.value !== nextId) {
            variantInput.value = nextId;
            variantInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
          variantInput.disabled = !radio || this.addonOn;
        }
        /* Ohne Zusatz: "id", "quantity" und properties[Gemstone set N] (nur so viele wie Sets).
           Mit Zusatz tragen items[0] (Steine samt Sets) und items[1] (Clay) den Kauf, die
           einfachen Felder sind aus. So schickt jedes Script, das das Formular abschickt
           (z. B. der Warenkorb in der Kopfzeile), alles Nötige mit. */
        const qtyInput = this.form?.querySelector('input[name="quantity"]');
        if (qtyInput) qtyInput.disabled = this.addonOn && Boolean(radio);
        props.forEach((input, i) => {
          input.value = this.picks[i] || '';
          input.disabled = this.addonOn || i >= this.cap;
        });
        this.querySelectorAll('[data-addon-field]').forEach(field => {
          let off = !(this.addonOn && radio);
          if (field.dataset.addonField === 'gem' && radio) field.value = radio.value;
          if (field.dataset.addonField === 'prop') {
            const i = parseInt(field.dataset.index || '0', 10);
            field.value = this.picks[i] || '';
            if (i >= this.cap) off = true;
          }
          field.disabled = off;
        });
        const wallets = this.querySelector('[data-wallets]');
        if (wallets) wallets.hidden = !radio || this.pending || this.addonOn;
        const active = Boolean(radio) && !this.pending;
        [this.mainBuy, this.stickyBuy].forEach(b => { if (b) b.disabled = !active; });
        const label = this.pending ? this.dataset.labelAdding : radio ? this.dataset.labelAdd : this.dataset.labelUnavailable;
        const offerCents = parseInt(radio?.dataset.priceCents || '0', 10) || 0;
        const total = radio ? (this.addonOn ? formatMoney(offerCents + addonCents()) : radio.dataset.price) : '';
        document.dispatchEvent(new CustomEvent('atelaye:price-change', { detail: { cents: radio ? (this.addonOn ? offerCents + addonCents() : offerCents) : 0 } }));
        const ctaLabel = this.querySelector('[data-cta-label]');
        if (ctaLabel) ctaLabel.textContent = label;
        const ctaPrice = this.querySelector('[data-cta-price]');
        if (ctaPrice) ctaPrice.textContent = radio && !this.pending ? '— ' + total : '';
        const stickyLabel = this.querySelector('[data-sticky-label]');
        if (stickyLabel) stickyLabel.textContent = label;
        const stickyName = this.querySelector('[data-sticky-name]');
        if (stickyName) stickyName.textContent = radio ? radio.dataset.name + ' · ' + chosenNames(this.picks.slice(0, this.cap), ', ') + (this.addonOn && addon ? ' + ' + (addon.dataset.name || '') : '') : '';
        const stickyPrice = this.querySelector('[data-sticky-price]');
        if (stickyPrice) stickyPrice.textContent = radio && !this.pending ? total : '';
        this.segs.forEach(seg => seg.setAttribute('aria-pressed', String(Boolean(radio) && seg.dataset.value === radio.value)));

        /* "Inside The Duo": Name, Mengen und Steine folgen der Auswahl. */
        const incOffer = this.querySelector('[data-inc-offer]');
        if (incOffer && radio) incOffer.textContent = radio.dataset.name;
        if (radio) {
          this.querySelectorAll('[data-inc-tpl]').forEach(el => {
            const tpl = (this.cap === 1 ? el.dataset.templateOne : el.dataset.template) || el.dataset.template || '';
            putSplit(el, fillTemplate(tpl, radio));
          });
        }
        renderRows();
        updateShip(offerCents);
      };
      this.radios.forEach(r => on(r, 'change', () => { if (this.error) { this.error.hidden = true; } this.updateOffer(); }));

      /* Leiste: die Angebote als Umschalter, gebaut aus den Radios (ein Zustand, zwei Anzeigen). */
      const segWrap = this.querySelector('[data-sticky-segs]');
      if (segWrap && this.radios.length > 1) {
        this.segs = this.radios.map(radio => {
          const seg = document.createElement('button');
          seg.type = 'button';
          seg.className = 'atg-seg';
          seg.dataset.value = radio.value;
          seg.textContent = radio.dataset.name || '';
          seg.disabled = radio.disabled;
          on(seg, 'click', () => {
            if (radio.disabled || radio.checked) return;
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          });
          return seg;
        });
        segWrap.replaceChildren(...this.segs);
      }

      const setAddon = state => {
        this.addonOn = Boolean(state) && Boolean(addon);
        if (addon) addon.classList.toggle('is-on', this.addonOn);
        if (addonToggle) addonToggle.setAttribute('aria-pressed', String(this.addonOn));
        if (addonLabel && addon) addonLabel.textContent = this.addonOn ? addon.dataset.labelAdded : addon.dataset.labelAdd;
        const incRow = this.querySelector('[data-inc-addon]');
        if (incRow) incRow.hidden = !this.addonOn;
        this.updateOffer();
      };
      on(addonToggle, 'click', () => setAddon(!this.addonOn));

      /* ---------- Steinfenster wie im Kit (Stand Kit-PDP v16) ----------
         Hängt an <body>; beim Entfernen der Section kommt es an seinen Platz zurück
         (disconnectedCallback). Gewählt wird in einem Entwurf: Reiter oben wechseln das Set,
         "Next" führt zum nächsten, erst "Use this selection" übernimmt, X verwirft.
         Das Plus auf einer Kachel öffnet im selben Fenster die Detailansicht (Bilder, 3D-Platz,
         Fakten); "Choose this set" setzt das Set dort in den aktiven Reiter. */
      let draft = null;
      let lastFocus = null;
      let openedFrom = 0;
      /* Offene Detailansicht: { name, pane, index, scroll, trigger }, sonst null. */
      let detail = null;
      const sheetPanel = sheet?.querySelector('[data-atg-sheet-panel]');
      const sheetHead = sheet?.querySelector('[data-atg-sheet-head]');
      const sheetBody = sheet?.querySelector('[data-atg-sheet-body]');
      const slotsWrap = sheet?.querySelector('[data-atg-sheet-slots]');
      const slotTabs = sheet ? [...sheet.querySelectorAll('[data-atg-sheet-slot]')] : [];
      const sheetGo = sheet?.querySelector('[data-atg-sheet-go]');
      const detailWrap = sheet?.querySelector('[data-atg-detail]');
      const detailBack = detailWrap?.querySelector('[data-atg-detail-back]');
      const panes = detailWrap ? [...detailWrap.querySelectorAll('[data-atg-dpane]')] : [];
      if (sheet) {
        document.querySelectorAll('[data-atg-sheet-for]').forEach(old => { if (old !== sheet && old.dataset.atgSheetFor === sheet.dataset.atgSheetFor) old.remove(); });
        document.body.appendChild(sheet);
      }
      const renderSheet = () => {
        if (!draft) return;
        const cap = this.cap;
        const multi = cap > 1;
        if (slotsWrap) { slotsWrap.hidden = !multi; slotsWrap.style.setProperty('--atg-slots', String(cap)); slotsWrap.dataset.count = String(cap); }
        if (sheetHead) sheetHead.classList.toggle('is-single', !multi);
        slotTabs.forEach((tab, i) => {
          tab.hidden = i >= cap;
          const set = setByName(draft.picks[i]);
          const isOn = i === draft.slot;
          tab.classList.toggle('is-on', isOn);
          tab.setAttribute('aria-pressed', String(isOn));
          const thumb = tab.querySelector('[data-atg-slot-thumb]');
          const name = tab.querySelector('[data-atg-slot-name]');
          if (thumb && thumb.dataset.name !== (set?.name || '')) { thumb.innerHTML = swatchHtml(set, 72); thumb.dataset.name = set?.name || ''; }
          if (name) name.textContent = set ? set.name : '';
        });
        const cur = draft.picks[draft.slot];
        const used = draft.picks.slice(0, cap);
        SETS.forEach(set => {
          const inSets = [];
          used.forEach((name, i) => { if (name === set.name) inSets.push(i + 1); });
          const isOn = cur === set.name;
          set.el.classList.toggle('is-on', isOn);
          set.pick.setAttribute('aria-pressed', String(isOn));
          const mark = set.el.querySelector('[data-atg-stone-mark]');
          if (!mark) return;
          if (multi && inSets.length) {
            mark.hidden = false;
            mark.textContent = inSets.join('+');
            mark.classList.toggle('is-other', !isOn);
          } else if (!multi && isOn) {
            mark.hidden = false;
            mark.textContent = '✓';
            mark.classList.remove('is-other');
          } else {
            mark.hidden = true;
          }
        });
        /* Knopf unten:
           · Detailansicht offen: "Choose this set" setzt das Set in den aktiven Reiter, "Selected",
             wenn es dort schon steht, gesperrt mit "Sold out", wenn es ausverkauft ist.
           · Sonst Duo/Trio: Set 1 führt über einen sichtbaren Knopf zu Set 2 usw. – nichts springt
             von selbst –, danach "Use this selection". */
        if (sheetGo) {
          const goLabel = sheetGo.querySelector('[data-atg-go-label]');
          const iconNext = sheetGo.querySelector('[data-atg-go-next]');
          const iconUse = sheetGo.querySelector('[data-atg-go-use]');
          if (detail) {
            const shown = setByName(detail.name);
            const sold = !shown || !shown.available;
            sheetGo.dataset.action = sold ? 'none' : 'choose';
            sheetGo.disabled = sold;
            if (goLabel) goLabel.textContent = sold ? sheetGo.dataset.lSold : (cur === detail.name ? sheetGo.dataset.lSelected : sheetGo.dataset.lChoose);
            if (iconNext) iconNext.hidden = true;
            if (iconUse) iconUse.hidden = sold;
          } else {
            const next = multi && draft.slot < cap - 1;
            sheetGo.dataset.action = next ? 'next' : 'use';
            sheetGo.disabled = false;
            if (goLabel) goLabel.textContent = next ? sheetGo.dataset.lNext : sheetGo.dataset.lUse;
            if (iconNext) iconNext.hidden = !next;
            if (iconUse) iconUse.hidden = next;
          }
        }
      };
      /* Kachel sichtbar machen, ohne dass sie unter der klebenden Gruppen-Überschrift landet. */
      const revealStone = el => {
        if (!el || !sheetBody) return;
        const box = sheetBody.getBoundingClientRect();
        const r = el.getBoundingClientRect();
        if (r.top < box.top + 96) sheetBody.scrollTop += r.top - box.top - 96;
        else if (r.bottom > box.bottom - 12) sheetBody.scrollTop += r.bottom - box.bottom + 12;
      };
      /* Fokus auf den Wähl-Knopf der aktiven Kachel (nicht auf den Rahmen). */
      const focusCurrentStone = () => {
        const cur = sheet?.querySelector('[data-atg-stone].is-on');
        revealStone(cur);
        (cur?.querySelector('[data-atg-stone-pick]') || cur)?.focus({ preventScroll: true });
      };

      /* ---------- Detailansicht ---------- */
      const paneSlides = pane => [...pane.querySelectorAll('[data-atg-dslide]')];
      const markDetail = i => {
        if (!detail) return;
        const pane = detail.pane;
        const slides = paneSlides(pane);
        detail.index = i;
        pane.querySelectorAll('[data-atg-dthumb]').forEach(btn => btn.setAttribute('aria-current', String(Number(btn.dataset.atgDthumb) === i)));
        const count = pane.querySelector('[data-atg-dcount]');
        if (count) count.textContent = (i + 1) + ' / ' + slides.length;
        const prev = pane.querySelector('[data-atg-dprev]');
        const nxt = pane.querySelector('[data-atg-dnext]');
        if (prev) prev.disabled = i === 0;
        if (nxt) nxt.disabled = i === slides.length - 1;
        /* Hinweis zum Beispielring nur auf der 3D-Folie. */
        const note = pane.querySelector('[data-atg-dnote]');
        if (note) note.hidden = !(slides[i] && slides[i].hasAttribute('data-atg-d3d'));
      };
      const goDetail = (i, instant) => {
        if (!detail) return;
        const track = detail.pane.querySelector('[data-atg-dtrack]');
        const slides = paneSlides(detail.pane);
        if (!track || !slides.length) return;
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: i * track.clientWidth, behavior: instant || reduceMotion.matches ? 'auto' : 'smooth' });
        markDetail(i);
      };
      const openDetail = (name, trigger) => {
        if (!detailWrap || !sheetBody) return;
        const pane = panes.find(p => p.dataset.setName === name);
        if (!pane) return;
        detail = { name, pane, index: 0, scroll: sheetBody.scrollTop, trigger: trigger || null };
        panes.forEach(p => { p.hidden = p !== pane; });
        sheetBody.hidden = true;
        detailWrap.hidden = false;
        detailWrap.scrollTop = 0;
        goDetail(0, true);
        renderSheet();
        detailBack?.focus({ preventScroll: true });
      };
      /* refocus = false, wenn danach etwas anderes den Fokus bekommt oder das Fenster zugeht. */
      const closeDetail = refocus => {
        if (!detail) return;
        const d = detail;
        detail = null;
        if (detailWrap) detailWrap.hidden = true;
        if (sheetBody) { sheetBody.hidden = false; sheetBody.scrollTop = d.scroll; }
        renderSheet();
        if (refocus !== false && d.trigger && d.trigger.isConnected) d.trigger.focus({ preventScroll: true });
      };
      /* Wischen im Streifen: Vorschaubilder, Zähler und Pfeile folgen der Position. */
      panes.forEach(pane => {
        const track = pane.querySelector('[data-atg-dtrack]');
        if (!track) return;
        let ticking = false;
        on(track, 'scroll', () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            ticking = false;
            if (!detail || detail.pane !== pane) return;
            const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
            if (i !== detail.index) markDetail(i);
          });
        }, { passive: true });
      });

      /* trigger = der angetippte Knopf. Safari fokussiert Buttons beim Antippen nicht, deshalb
         kommt der Fokus beim Schließen über ihn zurück, nicht über activeElement. */
      const openSheet = (slot, trigger) => {
        if (!sheet || !sheetPanel || !SETS.length) return;
        clearTimeout(this.sheetHide);
        lastFocus = trigger || document.activeElement;
        openedFrom = Math.max(0, Math.min(Number(slot) || 0, this.cap - 1));
        draft = { picks: this.picks.slice(), slot: openedFrom, gallery: galleryAt() };
        /* Das Fenster öffnet immer im Raster, nie in einer alten Detailansicht. */
        detail = null;
        if (detailWrap) detailWrap.hidden = true;
        if (sheetBody) sheetBody.hidden = false;
        renderSheet();
        sheet.hidden = false;
        document.documentElement.classList.add('atg-locked');
        if (sheetBody) sheetBody.scrollTop = 0;
        void sheetPanel.offsetWidth; /* Startlage festschreiben, sonst fährt das Fenster nicht ein */
        sheet.classList.add('is-open');
        focusCurrentStone();
      };
      const closeSheet = commit => {
        if (!sheet || sheet.hidden) return;
        closeDetail(false);
        const chosen = draft;
        draft = null;
        sheet.classList.remove('is-open');
        document.documentElement.classList.remove('atg-locked');
        clearTimeout(this.sheetHide);
        this.sheetHide = setTimeout(() => { sheet.hidden = true; }, reduceMotion.matches ? 0 : 420);
        if (commit && chosen) {
          this.picks = chosen.picks.slice();
          this.updateOffer();
          /* Galerie bleibt beim Bild des zuletzt bearbeiteten Sets. */
          showStone(this.picks[chosen.slot], true);
        } else if (chosen) {
          /* Verworfen: die Galerie zeigt wieder, was sie vor dem Öffnen gezeigt hat. */
          galleryGo(chosen.gallery, true);
        }
        const back = lastFocus && lastFocus !== document.body && document.contains(lastFocus) ? lastFocus : rows[openedFrom] || rows[0];
        back?.focus?.({ preventScroll: true });
      };
      this.querySelectorAll('[data-atg-st-open]').forEach(btn => on(btn, 'click', () => openSheet(btn.dataset.atgStOpen, btn)));
      on(sheet, 'click', e => {
        if (e.target.closest('[data-atg-sheet-close]')) { closeSheet(false); return; }
        if (!draft) return;
        /* Plus auf der Kachel: Details öffnen, ohne das Set zu wählen. */
        const detailButton = e.target.closest('[data-atg-stone-detail]');
        if (detailButton) {
          const tile = detailButton.closest('[data-atg-stone]');
          if (tile) openDetail(tile.dataset.setName, detailButton);
          return;
        }
        if (e.target.closest('[data-atg-detail-back]')) { closeDetail(); return; }
        if (e.target.closest('[data-atg-dprev]')) { goDetail(detail ? detail.index - 1 : 0); return; }
        if (e.target.closest('[data-atg-dnext]')) { goDetail(detail ? detail.index + 1 : 0); return; }
        const dthumb = e.target.closest('[data-atg-dthumb]');
        if (dthumb) { goDetail(Number(dthumb.dataset.atgDthumb) || 0); return; }
        const pick = e.target.closest('[data-atg-stone-pick]');
        const stone = pick ? pick.closest('[data-atg-stone]') : null;
        if (stone) {
          if (pick.disabled) return;
          draft.picks[draft.slot] = stone.dataset.setName;
          stone.classList.remove('is-pop');
          void stone.offsetWidth;
          stone.classList.add('is-pop');
          renderSheet();
          /* Angeklickter Stein = sein Bild in der Galerie. */
          showStone(stone.dataset.setName, true);
          return;
        }
        const tab = e.target.closest('[data-atg-sheet-slot]');
        if (tab) {
          draft.slot = Number(tab.dataset.atgSheetSlot) || 0;
          renderSheet();
          if (!detail) revealStone(sheet.querySelector('[data-atg-stone].is-on'));
          showStone(draft.picks[draft.slot], true);
          return;
        }
        if (e.target.closest('[data-atg-sheet-go]')) {
          const action = sheetGo?.dataset.action;
          if (action === 'choose' && detail) {
            /* Set in den aktiven Reiter übernehmen und zurück ins Raster, an seine Kachel. */
            const name = detail.name;
            draft.picks[draft.slot] = name;
            closeDetail(false);
            const chosenSet = setByName(name);
            if (chosenSet) {
              chosenSet.el.classList.remove('is-pop');
              void chosenSet.el.offsetWidth;
              chosenSet.el.classList.add('is-pop');
            }
            focusCurrentStone();
            showStone(name, true);
          } else if (action === 'next') {
            draft.slot += 1;
            renderSheet();
            focusCurrentStone();
            showStone(draft.picks[draft.slot], true);
          } else if (action === 'use') {
            closeSheet(true);
          }
        }
      });
      /* Escape: aus der Detailansicht zurück ins Raster, sonst schließen ohne zu übernehmen.
         Pfeiltasten blättern in der Detailansicht. Tab bleibt im Fenster. */
      on(document, 'keydown', e => {
        if (!sheet || sheet.hidden || !draft) return;
        if (e.key === 'Escape') {
          e.preventDefault();
          if (detail) closeDetail(); else closeSheet(false);
          return;
        }
        if (detail && (e.key === 'ArrowLeft' || e.key === 'ArrowRight')) {
          e.preventDefault();
          goDetail(detail.index + (e.key === 'ArrowRight' ? 1 : -1));
          return;
        }
        if (e.key !== 'Tab') return;
        const items = [...sheetPanel.querySelectorAll('button, [tabindex="0"]')].filter(el => !el.disabled && el.getClientRects().length > 0);
        if (!items.length) return;
        const firstItem = items[0];
        const lastItem = items[items.length - 1];
        if (!sheetPanel.contains(document.activeElement)) { e.preventDefault(); firstItem.focus(); return; }
        if (e.shiftKey && document.activeElement === firstItem) { e.preventDefault(); lastItem.focus(); }
        else if (!e.shiftKey && document.activeElement === lastItem) { e.preventDefault(); firstItem.focus(); }
      });
      /* Theme-Editor: einen Steinset-Block anklicken öffnet das Fenster an dieser Kachel;
         eine offene Detailansicht geht dabei zurück ins Raster. */
      on(document, 'shopify:block:select', e => {
        if (!sheet || !sheet.contains(e.target)) return;
        if (sheet.hidden || !draft) openSheet(0);
        closeDetail(false);
        revealStone(e.target);
      });
      on(document, 'shopify:block:deselect', e => { if (sheet && sheet.contains(e.target)) closeSheet(false); });

      this.updateOffer();

      /* Sterne: springen zu den Bewertungen dieser Section, sonst zum eingestellten Ziel. */
      const ratingLink = this.querySelector('[data-reviews-link]');
      on(ratingLink, 'click', event => {
        if (!(ratingLink.getAttribute('href') || '').startsWith('#')) return;
        let target = this.querySelector('[data-atg-reviews]');
        const key = (ratingLink.dataset.target || '').trim();
        if (!target && key) {
          target = document.getElementById(key.replace(/^#/, ''));
          if (!target) target = [...document.querySelectorAll('[id]')].find(el => el.id.endsWith('__' + key));
          if (!target) { try { target = document.querySelector(key); } catch {} }
        }
        if (!target) target = document.getElementById(ratingLink.hash.slice(1));
        if (!target) target = document.querySelector('.aty-reviews, #judgeme_product_reviews, #looxReviews');
        if (!target) return;
        event.preventDefault();
        const offset = parseFloat(getComputedStyle(this).getPropertyValue('--sticky-top')) || 24;
        window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - offset, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
        const hadTabindex = target.hasAttribute('tabindex');
        if (!hadTabindex) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
        if (!hadTabindex) target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
      });

      /* Ersatzweg, falls kein anderes Script das Formular übernimmt (der Warenkorb in der
         Kopfzeile fängt es sonst vorher ab und schickt die Felder selbst). */
      on(this.form, 'submit', async event => {
        if (event.submitter && !event.submitter.matches('[data-main-buy],[data-sticky-buy]')) return;
        event.preventDefault();
        if (this.pending) return;
        const radio = this.radios.find(r => r.checked && !r.disabled);
        if (!radio) { if (this.error) { this.error.textContent = this.dataset.selectError; this.error.hidden = false; } return; }
        this.pending = true;
        if (this.error) this.error.hidden = true;
        this.updateOffer();
        const properties = {};
        this.picks.slice(0, this.cap).forEach((name, i) => { if (name) properties[propBase + ' ' + (i + 1)] = name; });
        const items = [{ id: radio.value, quantity: 1, properties }];
        if (this.addonOn && addon) items.push({ id: addon.dataset.addonVariant, quantity: 1 });
        try {
          const response = await fetch(this.dataset.addUrl, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
          const data = await response.json();
          if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : this.dataset.error);
          window.location.assign(this.dataset.cartUrl);
        } catch (error) {
          if (!this.isConnected) return;
          if (this.error) { this.error.textContent = error.message || this.dataset.error; this.error.hidden = false; }
          this.pending = false;
          this.updateOffer();
        }
      });

      /* Galerie wie im Kit: ein Streifen für alle Medien. Handy wischt, Desktop steuert ihn
         über die Vorschaubilder; Punkte und Vorschaubilder stehen in derselben Reihenfolge. */
      const track = this.querySelector('[data-gal-track]');
      const slides = [...this.querySelectorAll('[data-slide]')];
      const thumbs = [...this.querySelectorAll('[data-thumb]')];
      const dots = [...this.querySelectorAll('[data-gal-dot]')];
      const view3dBtn = this.querySelector('[data-view3d]');
      let index = 0;
      const pauseSlide = slide => {
        slide.querySelectorAll('video').forEach(video => video.pause());
        slide.querySelectorAll('iframe').forEach(frame => {
          try {
            const origin = new URL(frame.src, location.href).origin;
            if (/youtube/.test(origin)) frame.contentWindow?.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), origin);
            if (/vimeo/.test(origin)) frame.contentWindow?.postMessage(JSON.stringify({ method: 'pause' }), origin);
          } catch {}
        });
      };
      const markSlide = i => {
        index = i;
        thumbs.forEach((thumb, n) => { thumb.classList.toggle('is-on', n === i); thumb.setAttribute('aria-pressed', String(n === i)); });
        dots.forEach((dot, n) => { dot.classList.toggle('is-on', n === i); if (n === i) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
        slides.forEach((slide, n) => { if (n !== i) pauseSlide(slide); });
        if (view3dBtn) view3dBtn.classList.toggle('is-active', slides[i]?.dataset.mediaType === 'model');
      };
      const goSlide = (i, instant) => {
        if (!track || !slides.length) return;
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: i * track.clientWidth, behavior: instant || reduceMotion.matches ? 'auto' : 'smooth' });
        markSlide(i);
      };
      if (track) {
        let ticking = false;
        on(track, 'scroll', () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            ticking = false;
            const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
            if (i !== index) markSlide(i);
          });
        }, { passive: true });
        on(track, 'keydown', e => {
          if (e.target !== track) return;
          if (e.key === 'ArrowRight') { e.preventDefault(); goSlide(index + 1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); goSlide(index - 1); }
        });
        /* Nach dem Drehen oder Verkleinern bleibt dasselbe Bild stehen. */
        on(window, 'resize', () => goSlide(index, true));
      }
      thumbs.forEach((thumb, i) => on(thumb, 'click', () => goSlide(i)));
      dots.forEach((dot, i) => on(dot, 'click', () => goSlide(i)));
      if (view3dBtn) on(view3dBtn, 'click', () => { const t = parseInt(view3dBtn.dataset.target || '0', 10); goSlide(isNaN(t) ? 0 : t); });
      /* Regel Stein → Bild, ohne Zuordnung von Hand: zuerst die Dateien des Steins ("Galeriebild",
         dann sein Foto), sonst ein Bild, dessen Alt-Text dem Steinnamen entspricht. Kein Treffer:
         die Galerie bleibt, wo sie ist. */
      const slideOf = set => {
        if (!set) return -1;
        for (const file of set.files) {
          const i = slides.findIndex(slide => slide.dataset.file === file);
          if (i >= 0) return i;
        }
        const name = set.name.trim().toLowerCase();
        return slides.findIndex(slide => (slide.dataset.alt || '').trim().toLowerCase() === name);
      };
      showStone = (name, instant) => {
        const i = slideOf(setByName(name));
        if (i >= 0 && i !== index) goSlide(i, instant);
      };
      galleryAt = () => index;
      galleryGo = (i, instant) => { if (typeof i === 'number' && i !== index) goSlide(i, instant); };

      const dialog = this.querySelector('dialog');
      const zoomContent = this.querySelector('[data-zoom-content]');
      const openZoom = btn => {
        const image = btn.querySelector('img');
        if (!image || !dialog || typeof dialog.showModal !== 'function') return;
        const clone = image.cloneNode(true);
        clone.removeAttribute('loading');
        clone.removeAttribute('sizes');
        clone.removeAttribute('srcset');
        clone.removeAttribute('fetchpriority');
        zoomContent.replaceChildren(clone);
        dialog.showModal();
      };
      this.querySelectorAll('.image-open').forEach(btn => on(btn, 'click', () => openZoom(btn)));
      on(this.querySelector('[data-close]'), 'click', () => dialog.close());
      on(dialog, 'click', e => { if (e.target === dialog) dialog.close(); });

      /* FAQ im Hallmark-Muster: die Antwortfläche (.atg-panel) fährt in Höhe und Deckkraft auf und
         zu (460 ms auf, 340 ms zu), das Plus dreht dabei zum ×. Bei „weniger Bewegung“ oder ohne
         WAAPI klappt der Browser das <details> nativ um, nur ohne Bewegung. */
      this.querySelectorAll('details.atg-q').forEach(item => {
        const summary = item.querySelector('summary');
        const panel = item.querySelector('.atg-panel');
        if (!summary || !panel || typeof panel.animate !== 'function') return;
        let run = null;
        on(summary, 'click', event => {
          /* „Weniger Bewegung“ wird bei jedem Klick geprüft: dann schaltet der Browser nativ um. */
          if (reduceMotion.matches) return;
          event.preventDefault();
          if (run) { run.cancel(); run = null; }
          if (!item.open || item.classList.contains('is-closing')) {
            item.classList.remove('is-closing');
            item.open = true;
            run = panel.animate(
              [{ height: '0px', opacity: 0 }, { height: panel.offsetHeight + 'px', opacity: 1 }],
              { duration: 460, easing: 'cubic-bezier(.22, 1, .36, 1)' }
            );
            run.onfinish = () => { run = null; };
          } else {
            item.classList.add('is-closing');
            run = panel.animate(
              [{ height: panel.offsetHeight + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
              { duration: 340, easing: 'cubic-bezier(.4, 0, .2, 1)' }
            );
            run.onfinish = () => { run = null; item.open = false; item.classList.remove('is-closing'); };
          }
        });
        this.lifecycle.signal.addEventListener('abort', () => { if (run) run.cancel(); }, { once: true });
      });

      if (this.mainBuy && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(([entry]) => { const st = this.querySelector('[data-sticky]'); if (st) st.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0; });
        this.observer.observe(this.mainBuy);
      }

      /* Lieferdatum: heute + N Werktage (bei einer Spanne der späteste Tag), im Format der
         Shop-Sprache, z. B. "Thu, Oct 1". Liquid hat es schon vorgeschrieben. */
      const elDelivery = this.querySelector('[data-delivery]');
      if (elDelivery) {
        const addWorkdays = n => {
          const d = new Date();
          let added = 0;
          while (added < n) {
            d.setDate(d.getDate() + 1);
            if (d.getDay() !== 0 && d.getDay() !== 6) added += 1;
          }
          return d;
        };
        const daysMin = parseInt(this.dataset.leadDays || '1', 10) || 1;
        const daysMax = parseInt(this.dataset.leadDaysMax || '0', 10) || 0;
        try {
          elDelivery.textContent = addWorkdays(Math.max(daysMin, daysMax)).toLocaleDateString(this.dataset.locale || 'en', { weekday: 'short', day: 'numeric', month: 'short' });
        } catch {}
      }

      /* Galerie klebt unter der Navigation: Versatz aus deren echter Höhe (wie im Kit),
         mindestens der Wert aus der Einstellung "Abstand Galerie oben". */
      const nav = document.querySelector('.aty-nav--solid');
      if (nav) {
        const base = parseFloat(getComputedStyle(this).getPropertyValue('--sticky-top')) || 0;
        const setStickyTop = () => this.style.setProperty('--sticky-top', Math.max(base, nav.offsetHeight + 20) + 'px');
        setStickyTop();
        on(window, 'resize', setStickyTop);
      }

      /* Schritt-Videos: stumm in Schleife, nur solange sie im Bild sind. Bei "weniger
         Bewegung" bleibt das Standbild stehen und man startet selbst. */
      const videos = [...this.querySelectorAll('[data-atg-video]')];
      if (videos.length) {
        const play = video => { const promise = video.play(); if (promise && typeof promise.catch === 'function') promise.catch(() => {}); };
        videos.forEach(video => { video.muted = true; });
        if (reduceMotion.matches) {
          videos.forEach(video => { video.controls = true; video.preload = 'metadata'; });
        } else if ('IntersectionObserver' in window) {
          this.videoObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => { if (entry.isIntersecting) play(entry.target); else entry.target.pause(); });
          }, { rootMargin: '120px 0px', threshold: 0.2 });
          videos.forEach(video => this.videoObserver.observe(video));
        } else {
          videos.forEach(play);
        }
      }

      /* Vorher/Nachher wie im Kit: Ziehen mit Maus oder Finger, Pfeiltasten am Griff (Shift =
         größere Schritte, Pos1/Ende = Anschlag). touch-action: pan-y lässt senkrechtes Wischen
         die Seite scrollen. Beim ersten Sichtkontakt schwenkt der Griff einmal kurz, damit man
         sieht, dass man ziehen kann (nicht bei "weniger Bewegung", nicht nach eigenem Anfassen). */
      this.compareObservers = [];
      this.querySelectorAll('[data-atg-compare]').forEach(stage => {
        const handle = stage.querySelector('[data-atg-compare-handle]');
        const labelB = stage.dataset.labelBefore || '';
        const labelA = stage.dataset.labelAfter || '';
        let pos = 50;
        let dragging = false;
        let touched = false;
        let hintRaf = 0;
        const clamp01 = v => (v < 0 ? 0 : v > 1 ? 1 : v);
        const setPos = p => {
          pos = p < 0 ? 0 : p > 100 ? 100 : p;
          stage.style.setProperty('--pos', pos + '%');
          if (handle) {
            handle.setAttribute('aria-valuenow', Math.round(pos));
            handle.setAttribute('aria-valuetext', Math.round(pos) + '% ' + labelB + ', ' + Math.round(100 - pos) + '% ' + labelA);
          }
        };
        const fromEvent = e => {
          const r = stage.getBoundingClientRect();
          if (r.width) setPos((e.clientX - r.left) / r.width * 100);
        };
        const stopHint = () => {
          touched = true;
          if (hintRaf) cancelAnimationFrame(hintRaf);
          hintRaf = 0;
        };
        this.lifecycle.signal.addEventListener('abort', stopHint, { once: true });
        on(stage, 'pointerdown', e => {
          if (e.button !== undefined && e.button !== 0) return;
          stopHint();
          dragging = true;
          stage.classList.add('is-drag');
          try { stage.setPointerCapture(e.pointerId); } catch {}
          fromEvent(e);
          if (e.pointerType === 'mouse' && handle) { e.preventDefault(); handle.focus({ preventScroll: true }); }
        });
        on(stage, 'pointermove', e => { if (dragging) fromEvent(e); });
        ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(type => on(stage, type, () => { dragging = false; stage.classList.remove('is-drag'); }));
        on(handle, 'keydown', e => {
          const step = e.shiftKey ? 10 : 4;
          let next = null;
          if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') next = pos - step;
          if (e.key === 'ArrowRight' || e.key === 'ArrowUp') next = pos + step;
          if (e.key === 'Home') next = 0;
          if (e.key === 'End') next = 100;
          if (next === null) return;
          e.preventDefault();
          stopHint();
          setPos(next);
        });
        const hint = () => {
          if (touched || reduceMotion.matches) return;
          const keys = [[0, 50], [520, 30], [1180, 70], [1650, 50]];
          const ease = t => (t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2);
          let t0 = null;
          const tick = now => {
            if (touched) return;
            if (t0 === null) t0 = now;
            const t = now - t0;
            let i = 1;
            while (i < keys.length - 1 && t > keys[i][0]) i++;
            const a = keys[i - 1];
            const b = keys[i];
            setPos(a[1] + (b[1] - a[1]) * ease(clamp01((t - a[0]) / (b[0] - a[0]))));
            if (t < keys[keys.length - 1][0]) hintRaf = requestAnimationFrame(tick);
            else { setPos(50); hintRaf = 0; }
          };
          hintRaf = requestAnimationFrame(tick);
        };
        setPos(50);
        if ('IntersectionObserver' in window) {
          const seen = new IntersectionObserver(entries => {
            if (!entries[0].isIntersecting) return;
            seen.disconnect();
            setTimeout(hint, 350);
          }, { threshold: 0.55 });
          seen.observe(stage);
          this.compareObservers.push(seen);
        }
      });

      /* Bewertungs-Laufband im Theme-Editor: eine angeklickte Bewertung bleibt stehen und
         rückt ins Bild, beim Abwählen läuft das Band weiter. Im Shop ohne Wirkung. */
      const rvList = this.querySelector('[data-atg-marquee]');
      const rvTrack = rvList?.querySelector('.atg-reviews-track');
      if (rvList && rvTrack) {
        on(document, 'shopify:block:select', e => {
          if (!rvList.contains(e.target)) return;
          rvTrack.style.animation = 'none';
          rvList.scrollLeft = 0;
          rvList.scrollLeft = Math.max(0, e.target.getBoundingClientRect().left - rvList.getBoundingClientRect().left - 24);
        });
        on(document, 'shopify:block:deselect', e => {
          if (!rvList.contains(e.target)) return;
          rvTrack.style.animation = '';
          rvList.scrollLeft = 0;
        });
      }
    }
    disconnectedCallback() {
      this.lifecycle?.abort();
      this.observer?.disconnect();
      this.videoObserver?.disconnect();
      this.compareObservers?.forEach(observer => observer.disconnect());
      this.querySelector('dialog')?.close();
      /* Steinfenster zurück an seinen Platz: geht die Section weg, geht es mit; wird sie nur
         verschoben, findet das nächste connectedCallback es wieder. */
      clearTimeout(this.sheetHide);
      document.documentElement.classList.remove('atg-locked');
      if (this.sheet) {
        this.sheet.classList.remove('is-open');
        this.sheet.hidden = true;
        if (this.sheetHome && this.sheetHome !== this.sheet.parentNode) this.sheetHome.appendChild(this.sheet);
      }
      this.initialized = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelaye-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('atelaye-letters')) {
    (function () {
      function clamp(v) { return v < 0 ? 0 : (v > 1 ? 1 : v); }
      function ease(t) { return t < .5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }
      function lerp(a, b, t) { return a + (b - a) * t; }
      /* Leichte Unregelmäßigkeit, damit die Briefe wie hingeworfen wirken (wiederholt sich nach 8) */
      var TILT = [-1.6, 1.2, -.6, 1.5, -1.1, .8, -1.3, 1];
      var DROP = [4, -5, 2, -3, 5, -2, 4, -4];
      var SPIN = [-7, 6, -5, 8, -6, 5, -8, 7];
      var PILE = [[-3.2, -10, 6], [2.4, 12, -4], [-1.4, -6, 8], [3, 9, -6], [-2.2, -12, 4], [1.6, 7, -8], [-2.8, -8, 5], [2, 10, -3]];
      /* Ablauf in Bildschirmhöhen: Klappe öffnen, je Brief "step", am Ende sinkt der Umschlag weg */
      var INTRO = .45, OUTRO = .55, HOLD = .3, RISE = .42;

      customElements.define('atelaye-letters', class extends HTMLElement {
        connectedCallback() {
          if (this.ac || window.matchMedia('(prefers-reduced-motion: reduce)').matches) { return; }
          this.ac = new AbortController();
          var opt = { passive: true, signal: this.ac.signal };
          var self = this;
          this.stage = this.querySelector('.arl__stage');
          this.head = this.querySelector('.arl__head');
          this.desk = this.querySelector('[data-desk]');
          this.back = this.querySelector('.arl__env-back');
          this.flap = this.querySelector('.arl__env-flap');
          this.front = this.querySelector('.arl__env-front');
          this.items = Array.prototype.map.call(this.querySelectorAll('[data-letter]'), function (el) { return { el: el, z: -1, clip: null, lift: -1 }; });
          this.step = (parseFloat(this.dataset.step) || 55) / 100;
          this.frame = 0;
          this.lastU = null;
          this.setAttribute('data-ready', '');
          this.schedule = function () { if (!self.frame) { self.frame = requestAnimationFrame(function () { self.update(); }); } };
          this.remeasure = function () { self.measure(); };
          window.addEventListener('scroll', this.schedule, opt);
          window.addEventListener('resize', this.remeasure, opt);
          window.addEventListener('load', this.remeasure, opt);
          if (document.fonts && document.fonts.ready) { document.fonts.ready.then(this.remeasure); }
          if ('ResizeObserver' in window) { this.ro = new ResizeObserver(this.remeasure); this.ro.observe(this.stage); }
          this.measure();
        }

        disconnectedCallback() {
          if (!this.ac) { return; }
          this.ac.abort();
          this.ac = null;
          if (this.ro) { this.ro.disconnect(); }
          cancelAnimationFrame(this.frame);
          this.frame = 0;
        }

        /* Maße: Briefbreite, Umschlag, Landeplätze. Bezugshöhe ist die Bühne (100svh), nicht das
           Fenster, damit die Adressleiste auf dem Handy nichts verschiebt. */
        measure() {
          if (!this.ac) { return; }
          var W = this.stage.clientWidth, H = this.stage.clientHeight;
          if (!W || !H) { return; }
          var N = this.items.length;
          var narrow = W < 750;
          var side = Math.max(24, W * .035);
          var fan = false, lw = 0;
          /* Desktop: alle Briefe nebeneinander (Ränder überlappen 4 %), wenn jeder mindestens 240 px breit
             sein kann, sonst Stapel */
          if (!narrow && N > 1) {
            lw = Math.min(380, (W - 2 * side) / (N - (N - 1) * .04));
            fan = lw >= 240;
          }
          if (!fan) { lw = narrow ? Math.min(350, W - 44) : Math.min(400, W * .36); }
          this.desk.style.setProperty('--arl-lw', lw.toFixed(1) + 'px');
          this.desk.style.setProperty('--arl-fs', Math.max(12, Math.min(narrow ? 16 : 17, lw * .056)).toFixed(2) + 'px');
          var lh = 0;
          this.items.forEach(function (it) { it.el.style.height = ''; });
          this.items.forEach(function (it) { lh = Math.max(lh, it.el.offsetHeight); });
          this.items.forEach(function (it) { it.el.style.height = lh + 'px'; });

          var ew = narrow ? Math.min(W * .72, 300) : Math.min(460, Math.max(300, lw * 1.3));
          var eh = ew * .62;
          this.desk.style.setProperty('--arl-ew', ew.toFixed(1) + 'px');
          this.desk.style.setProperty('--arl-eh', eh.toFixed(1) + 'px');
          var pad = Math.max(14, H * .025);
          var bandTop = this.head.offsetTop + this.head.offsetHeight + Math.max(18, H * .03);
          /* Umschlag ragt von unten herein: 70 % sichtbar, bei wenig Platz tiefer (bis 30 %) */
          var envTop = Math.min(H - eh * .3, Math.max(H - eh * .7, bandTop + lh + pad));
          var bandH = Math.max(80, envTop - pad - bandTop);
          /* Ohne Umschlag (am Ende) bekommen die Briefe den ganzen Platz bis unten und dürfen wachsen.
             Reserve für Neigung und Versatz der äußeren Briefe, damit keine Ecke an den Rand stößt. */
          var bandHF = Math.max(bandH, H - pad * 2 - bandTop);
          var mid = (N - 1) / 2;
          function place(bh, reserve, least) {
            var sc = Math.max(least, Math.min(1, (bh - reserve) / lh)), cy = bandTop + bh / 2;
            var spacing = fan ? Math.min(lw * sc * 1.04, (W - 2 * side - lw * sc) / (N - 1)) : 0;
            return function (it, i) {
              if (fan) {
                var k = mid ? (i - mid) / mid : 0;
                return { x: W / 2 + (i - mid) * spacing, y: cy + k * k * 14 + DROP[i % 8], r: (i - mid) * 1.8 + TILT[i % 8], s: sc };
              }
              var p = PILE[i % 8];
              return { x: W / 2 + p[1] * (narrow ? .5 : 1), y: cy + p[2], r: p[0] * (narrow ? .7 : 1), s: sc };
            };
          }
          this.targets = this.items.map(place(bandH, fan ? 0 : 20, 0));
          this.finals = this.items.map(place(bandHF, fan ? 68 : 30, this.targets[0].s));
          this.W = W; this.H = H; this.lw = lw; this.lh = lh; this.ew = ew; this.eh = eh; this.envTop = envTop;
          this.sIn = Math.min(1, ew * .86 / lw);
          /* Fächer: Briefe überlappen sich zeitlich, Stapel: jeder liegt kurz allein oben zum Lesen */
          this.D = this.step * (fan ? 1.2 : .6);
          this.sinkAt = INTRO + Math.max(0, N - 1) * this.step + this.D;
          this.L = this.sinkAt + OUTRO;
          this.style.height = Math.round(H * (1 + this.L + HOLD)) + 'px';
          this.lastU = null;
          this.schedule();
        }

        update() {
          this.frame = 0;
          if (!this.ac || !this.targets) { return; }
          var rect = this.getBoundingClientRect();
          if (rect.bottom < -100 || rect.top > window.innerHeight + 100) { return; }
          var u = Math.max(0, Math.min(this.L, -rect.top / this.H));
          if (u === this.lastU) { return; }
          this.lastU = u;
          var W = this.W, H = this.H, lw = this.lw, lh = this.lh, ew = this.ew, eh = this.eh, sIn = this.sIn;

          /* Umschlag: Klappe klappt in .35 Bildschirmhöhen auf, am Ende sinkt alles samt offener Klappe nach unten weg */
          var fa = 180 * ease(clamp(u / .35));
          var sink = ease(clamp((u - this.sinkAt) / .4));
          var ex = (W - ew) / 2;
          var ey = this.envTop + sink * (H - this.envTop + eh * .56 + 30);
          var et = 'translate3d(' + ex.toFixed(1) + 'px, ' + ey.toFixed(1) + 'px, 0)';
          this.back.style.transform = et;
          this.front.style.transform = et;
          this.flap.style.transform = et + ' perspective(' + Math.round(ew * 3) + 'px) rotateX(' + fa.toFixed(1) + 'deg)';
          var open = fa > 90;
          if (open !== this.open) { this.open = open; this.flap.classList.toggle('is-open', open); }

          /* Briefe: erst aus der Tasche nach oben (Teil in der Tasche per Clip weg), dann an ihren Platz */
          var cx0 = W / 2;
          var yIn = ey + eh * .1 + lh * sIn / 2;
          var yOut = ey - 6 - lh * sIn / 2;
          var depth = eh * .5;
          function vy(dx) { return ey + depth * (1 - Math.min(1, Math.abs(dx) / (ew / 2))); }
          for (var i = 0; i < this.items.length; i++) {
            var it = this.items[i];
            var t = this.targets[i];
            var q = clamp((u - INTRO - i * this.step) / this.D);
            var x = cx0, y, r = 0, s = sIn, z, clip = '', lift;
            if (q < RISE) {
              y = lerp(yIn, yOut, ease(q / RISE));
              lift = .5 * ease(q / RISE);
              z = q > 0 ? 100 : 5;
              var top = y - lh * s / 2;
              var half = lw * s / 2;
              var yl = (vy(half) - top) / s;
              var yc = (vy(0) - top) / s;
              if (yl < lh || yc < lh) {
                clip = 'polygon(0 0, 100% 0, 100% ' + yl.toFixed(1) + 'px, 50% ' + yc.toFixed(1) + 'px, 0 ' + yl.toFixed(1) + 'px)';
              }
            } else {
              var e = ease((q - RISE) / (1 - RISE));
              var arc = Math.sin(Math.PI * e);
              /* Landeplatz: solange der Umschlag da ist darüber, danach auf dem frei gewordenen Platz */
              var f = this.finals[i];
              x = lerp(cx0, lerp(t.x, f.x, sink), e);
              y = lerp(yOut, lerp(t.y, f.y, sink), e) - arc * lh * .08;
              r = lerp(0, lerp(t.r, f.r, sink), e) + arc * SPIN[i % 8];
              s = lerp(sIn, lerp(t.s, f.s, sink), e);
              z = q < 1 ? 100 : 10 + i;
              lift = .5 * (1 - e) + .5 * arc;
            }
            it.el.style.transform = 'translate3d(' + (x - lw / 2).toFixed(1) + 'px, ' + (y - lh / 2).toFixed(1) + 'px, 0) rotate(' + r.toFixed(2) + 'deg) scale(' + s.toFixed(4) + ')';
            if (clip !== it.clip) { it.clip = clip; it.el.style.clipPath = clip; }
            lift = Math.round(lift * 50) / 50;
            if (lift !== it.lift) { it.lift = lift; it.el.style.setProperty('--arl-lift', lift); }
            if (z !== it.z) { it.z = z; it.el.style.zIndex = z; }
          }
        }
      });
    })();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelaye-silver-clay"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('atelaye-clay')) {
  customElements.define('atelaye-clay', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.classList.add('atc-enhanced');
      this.lifecycle = new AbortController();
      const on = (node, event, fn, opts) => node?.addEventListener(event, fn, { signal: this.lifecycle.signal, ...(opts||{}) });
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.radios = [...this.querySelectorAll('[data-offer]')];
      this.form = this.querySelector('.atc-form');
      this.mainBuy = this.querySelector('[data-main-buy]');
      this.stickyBuy = this.querySelector('[data-sticky-buy]');
      this.error = this.querySelector('[data-error-message]');
      this.pending = false;
      const first = this.radios.find(r => !r.disabled);
      if (first && !this.radios.some(r => r.checked && !r.disabled)) first.checked = true;
      let selectVariantMedia = () => {};

      const esc = value => String(value == null ? '' : value).replace(/[&<>"']/g, ch => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]));

      /* Geld so, wie Shopify es schreibt: Muster aus dem money-Filter für 1234,56 (z. B. "€1,234.56"),
         daraus Zeichen vor und nach der Zahl, Tausender- und Dezimaltrenner. Gilt auch für
         andere Währungen der Markets, weil Liquid das Muster in der Besucherwährung liefert. */
      const moneySample = this.dataset.moneySample || '';
      const moneyMatch = moneySample.match(/\d[\d.,'\s  ]*\d/);
      const formatMoney = cents => {
        cents = Math.round(Number(cents) || 0);
        if (!moneyMatch) return (cents / 100).toFixed(2);
        const num = moneyMatch[0];
        const dec = /[.,]\d{2}$/.test(num) ? num.charAt(num.length - 3) : '';
        const intPart = dec ? num.slice(0, -3) : num;
        const thou = intPart.replace(/\d/g, '').charAt(0);
        const whole = String(Math.floor(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, thou);
        /* Ohne ",00" wie money_without_trailing_zeros: 161 € statt 161,00 €, 161,10 € bleibt. */
        const frac = dec && cents % 100 ? dec + String(cents % 100).padStart(2, '0') : '';
        return moneySample.slice(0, moneyMatch.index) + whole + frac + moneySample.slice(moneyMatch.index + num.length);
      };

      /* Inhaltszeile: " — " teilt in Hauptzeile und kleine Zeile darunter, wie in Liquid. */
      const putSplit = (el, value) => {
        const parts = String(value == null ? '' : value).split(' — ');
        const main = parts.shift();
        const sub = parts.join(' — ');
        el.innerHTML = '<span class="atc-inc-main">' + esc(main) + '</span>' + (sub ? '<small class="atc-inc-sub">' + esc(sub) + '</small>' : '');
      };

      /* Edelstein-Zusatz: an/aus über "Add". Der Preis steckt danach im Kaufbutton und in der
         Leiste; Shop Pay & Co. verschwinden, solange er gewählt ist (sie kaufen nur den Clay). */
      const addon = this.querySelector('[data-addon]');
      const addonToggle = addon?.querySelector('[data-addon-toggle]');
      const addonLabel = addon?.querySelector('[data-addon-label]');
      const addonCents = () => (addon ? parseInt(addon.dataset.priceCents || '0', 10) || 0 : 0);
      this.addonOn = false;
      this.pick = '';

      /* Gratisversand-Zeile: "ab 159 €", "mit einem Set gratis" oder "gratis". */
      const ship = this.querySelector('[data-atc-ship]');
      const shipText = ship?.querySelector('[data-atc-ship-text]');
      const updateShip = offerCents => {
        if (!ship || !shipText) return;
        const limit = parseInt(ship.dataset.threshold || '0', 10) || 0;
        if (!limit || !offerCents) { ship.hidden = true; return; }
        const withAddon = offerCents + addonCents();
        let text = ship.dataset.tFrom || '';
        let free = false;
        if (offerCents >= limit || (this.addonOn && withAddon >= limit)) { text = ship.dataset.tFree || ''; free = true; }
        else if (withAddon >= limit) text = ship.dataset.tAdd || '';
        shipText.textContent = text;
        ship.classList.toggle('is-free', free);
        ship.hidden = !text;
      };

      this.segs = [];
      this.updateOffer = () => {
        const radio = this.radios.find(r => r.checked && !r.disabled);
        const variantInput = this.querySelector('input[data-variant-id]');
        if (variantInput) {
          const nextId = radio?.value || '';
          if (variantInput.value !== nextId) {
            variantInput.value = nextId;
            variantInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
          variantInput.disabled = !radio || this.addonOn;
        }
        /* Mit Zusatz tragen items[0] (Clay) und items[1] (Set) den Kauf, "id" und "quantity"
           sind aus. So schickt jedes Script, das das Formular abschickt (z. B. der Warenkorb
           in der Kopfzeile), beide Artikel mit. */
        const qtyInput = this.form?.querySelector('input[name="quantity"]');
        if (qtyInput) qtyInput.disabled = this.addonOn && Boolean(radio);
        this.querySelectorAll('[data-addon-field]').forEach(field => {
          field.disabled = !(this.addonOn && radio);
          if (field.dataset.addonField === 'clay' && radio) field.value = radio.value;
          if (field.dataset.addonField === 'stone') field.value = this.pick || '';
        });
        const wallets = this.querySelector('[data-wallets]');
        if (wallets) wallets.hidden = !radio || radio.dataset.nativeCheckout !== 'true' || this.pending || this.addonOn;
        const active = Boolean(radio) && !this.pending;
        [this.mainBuy, this.stickyBuy].forEach(b => { if (b) b.disabled = !active; });
        const label = this.pending ? this.dataset.labelAdding : radio ? this.dataset.labelAdd : this.dataset.labelUnavailable;
        const offerCents = parseInt(radio?.dataset.priceCents || '0', 10) || 0;
        const total = radio ? (this.addonOn ? formatMoney(offerCents + addonCents()) : radio.dataset.price) : '';
        document.dispatchEvent(new CustomEvent('atelaye:price-change', { detail: { cents: radio ? (this.addonOn ? offerCents + addonCents() : offerCents) : 0 } }));
        const ctaLabel = this.querySelector('[data-cta-label]');
        if (ctaLabel) ctaLabel.textContent = label;
        const ctaPrice = this.querySelector('[data-cta-price]');
        if (ctaPrice) ctaPrice.textContent = radio && !this.pending ? '— ' + total : '';
        const stickyLabel = this.querySelector('[data-sticky-label]');
        if (stickyLabel) stickyLabel.textContent = label;
        const stickyName = this.querySelector('[data-sticky-name]');
        if (stickyName) stickyName.textContent = radio ? radio.dataset.name + ' · ' + radio.dataset.grams + ' g' + (this.addonOn && this.pick ? ' + ' + this.pick : '') : '';
        const stickyPrice = this.querySelector('[data-sticky-price]');
        if (stickyPrice) stickyPrice.textContent = radio && !this.pending ? total : '';
        this.segs.forEach(seg => seg.setAttribute('aria-pressed', String(Boolean(radio) && seg.dataset.value === radio.value)));

        /* "Inside The Trio": Name und Mengen folgen dem Angebot. */
        const incOffer = this.querySelector('[data-inc-offer]');
        if (incOffer && radio) incOffer.textContent = radio.dataset.name;
        if (radio) {
          this.querySelectorAll('[data-inc-tpl]').forEach(el => {
            const tpl = (radio.dataset.pack === '1' ? el.dataset.templateOne : el.dataset.template) || el.dataset.template || '';
            putSplit(el, tpl.split('{count}').join(radio.dataset.pack || '1').split('{grams}').join(radio.dataset.grams || '').split('{offer}').join(radio.dataset.name || ''));
          });
        }
        updateShip(offerCents);
        selectVariantMedia(radio);
      };
      this.radios.forEach(r => on(r, 'change', () => { if (this.error) { this.error.hidden = true; } this.updateOffer(); }));

      /* Leiste: die Angebote als Umschalter, gebaut aus den Radios (ein Zustand, zwei Anzeigen). */
      const segWrap = this.querySelector('[data-sticky-segs]');
      if (segWrap && this.radios.length > 1) {
        this.segs = this.radios.map(radio => {
          const seg = document.createElement('button');
          seg.type = 'button';
          seg.className = 'atc-seg';
          seg.dataset.value = radio.value;
          seg.textContent = radio.dataset.name || '';
          seg.disabled = radio.disabled;
          on(seg, 'click', () => {
            if (radio.disabled || radio.checked) return;
            radio.checked = true;
            radio.dispatchEvent(new Event('change', { bubbles: true }));
          });
          return seg;
        });
        segWrap.replaceChildren(...this.segs);
      }

      const setAddon = state => {
        this.addonOn = Boolean(state) && Boolean(addon);
        if (addon) addon.classList.toggle('is-on', this.addonOn);
        if (addonToggle) addonToggle.setAttribute('aria-pressed', String(this.addonOn));
        if (addonLabel && addon) addonLabel.textContent = this.addonOn ? addon.dataset.labelAdded : addon.dataset.labelAdd;
        const incRow = this.querySelector('[data-inc-addon]');
        if (incRow) incRow.hidden = !this.addonOn;
        this.updateOffer();
      };
      on(addonToggle, 'click', () => setAddon(!this.addonOn));

      /* Steinauswahl wie im Kit. Das Fenster hängt an <body>; beim Entfernen der Section
         kommt es an seinen Platz zurück (disconnectedCallback). Gewählt wird in einem
         Entwurf, erst der Knopf unten übernimmt ihn und schaltet den Zusatz dazu. */
      const sheet = this.querySelector('[data-atc-sheet]');
      this.sheet = sheet;
      this.sheetHome = sheet?.parentNode || null;
      /* Kachel = Rahmen (el) mit Wähl-Knopf (pick) und Plus für die Detailansicht. */
      const SETS = sheet ? [...sheet.querySelectorAll('[data-atc-stone]')].map(el => ({
        name: el.dataset.setName || '',
        kind: el.dataset.kind || 'set',
        meta: el.dataset.meta || '',
        count: el.dataset.count || '',
        thumb: el.dataset.thumb || '',
        swatch: el.dataset.swatch || '',
        colours: (el.dataset.colours || '').split(',').map(c => c.trim()).filter(c => /^#?[0-9a-z]{3,8}$/i.test(c)),
        pick: el.querySelector('[data-atc-stone-pick]') || el,
        el
      })) : [];
      /* Ohne Foto zeichnet die Kachel die Steine aus den hinterlegten Farben. */
      const gemSvg = set => {
        const cols = set.colours.length ? set.colours : ['#D2CBBB'];
        let out = '<svg viewBox="0 0 100 100" aria-hidden="true" focusable="false">';
        if (set.kind === 'oval') out += '<ellipse cx="50" cy="50" rx="22" ry="27" fill="' + cols[0] + '"/>';
        else if (set.kind === 'emerald') out += '<path d="M35 25h30l7 7v36l-7 7H35l-7-7V32Z" fill="' + cols[0] + '"/>';
        else [[27, 25], [57, 20], [79, 33], [24, 50], [50, 47], [76, 61], [34, 73], [63, 78]].forEach((pt, i) => { out += '<circle cx="' + pt[0] + '" cy="' + pt[1] + '" r="7" fill="' + cols[i % cols.length] + '"/>'; });
        return out + '</svg>';
      };
      SETS.forEach(set => {
        const box = set.el.querySelector('[data-atc-stone-img]');
        if (box && !box.querySelector('img')) box.insertAdjacentHTML('beforeend', gemSvg(set));
      });
      /* Runder Swatch wie im Kit: eigenes Swatch-Bild, sonst das Foto, sonst die Grafik. */
      const swatchHtml = (set, size) => (set.swatch || set.thumb)
        ? '<img src="' + esc(set.swatch || set.thumb) + '" alt="" width="' + size + '" height="' + size + '" loading="eager" decoding="async">'
        : gemSvg(set);
      /* Karte im Zusatz-Kasten: runder Swatch + Name des gewählten Sets, darunter im Link vier
         andere Steine als Punkte. Swatch und Link öffnen dasselbe Fenster. */
      const stRow = addon?.querySelector('[data-atc-st-row]');
      const stThumb = addon?.querySelector('[data-atc-st-thumb]');
      const stName = addon?.querySelector('[data-atc-st-name]');
      const stStack = addon?.querySelector('[data-atc-st-stack]');
      const stOpeners = addon ? [...addon.querySelectorAll('[data-atc-st-open]')] : [];
      const stChange = addon?.querySelector('[data-atc-stones]')?.dataset.lChange || '';
      this.pick = (SETS.find(set => set.name === (stName?.textContent || '').trim()) || SETS[0] || {}).name || '';
      const renderPick = () => {
        const set = SETS.find(item => item.name === this.pick);
        if (!set) return;
        if (stThumb && (stThumb.dataset.name !== set.name || !stThumb.firstElementChild)) {
          const swapped = Boolean(stThumb.dataset.name) && stThumb.dataset.name !== set.name;
          stThumb.innerHTML = swatchHtml(set, 112);
          stThumb.dataset.name = set.name;
          if (swapped && stRow && !reduceMotion.matches) {
            stRow.classList.remove('is-swap');
            void stRow.offsetWidth;
            stRow.classList.add('is-swap');
          }
        }
        if (stName) stName.textContent = set.name;
        if (stRow) stRow.setAttribute('aria-label', set.name + '. ' + stChange);
        if (stStack) {
          const others = SETS.filter(item => item.name !== set.name);
          const show = [];
          [1, 3, others.length - 3, others.length - 1].forEach(i => { const item = others[i]; if (item && show.indexOf(item) === -1) show.push(item); });
          const key = show.map(item => item.name).join('|');
          if (stStack.dataset.key !== key) {
            stStack.innerHTML = show.map(item => '<span class="atc-st-dot">' + swatchHtml(item, 52) + '</span>').join('');
            stStack.dataset.key = key;
          }
        }
        const incName = this.querySelector('[data-inc-addon-name]');
        if (incName) incName.textContent = set.name;
        const incQty = this.querySelector('[data-inc-addon-qty]');
        if (incQty) incQty.textContent = set.count;
      };
      renderPick();

      /* Gewählt wird in einem Entwurf (draft = Name des Sets), erst der Knopf unten übernimmt ihn
         und schaltet den Zusatz dazu. Das Plus auf einer Kachel öffnet im selben Fenster die
         Detailansicht (Bilder, 3D-Platz, Fakten); "Choose this set" setzt das Set dort als Entwurf
         und führt zurück ins Raster. */
      let draft = null;
      let lastFocus = null;
      /* Offene Detailansicht: { name, pane, index, scroll, trigger }, sonst null. */
      let detail = null;
      const sheetPanel = sheet?.querySelector('[data-atc-sheet-panel]');
      const sheetBody = sheet?.querySelector('[data-atc-sheet-body]');
      const sheetGo = sheet?.querySelector('[data-atc-sheet-go]');
      const goLabel = sheetGo?.querySelector('[data-atc-go-label]');
      const detailWrap = sheet?.querySelector('[data-atc-detail]');
      const detailBack = detailWrap?.querySelector('[data-atc-detail-back]');
      const panes = detailWrap ? [...detailWrap.querySelectorAll('[data-atc-dpane]')] : [];
      if (sheet) {
        document.querySelectorAll('[data-atc-sheet-for]').forEach(old => { if (old !== sheet && old.dataset.atcSheetFor === sheet.dataset.atcSheetFor) old.remove(); });
        document.body.appendChild(sheet);
      }
      const renderSheet = () => {
        if (!draft) return;
        SETS.forEach(set => {
          const isOn = set.name === draft;
          set.el.classList.toggle('is-on', isOn);
          set.pick.setAttribute('aria-pressed', String(isOn));
          const mark = set.el.querySelector('[data-atc-stone-mark]');
          if (mark) mark.hidden = !isOn;
        });
        /* Knopf unten: in der Detailansicht "Choose this set" bzw. "Selected", wenn das Set schon
           gewählt ist; sonst "Add to order · 14 €", solange der Zusatz aus ist, danach
           "Use this selection". */
        if (!sheetGo) return;
        sheetGo.dataset.action = detail ? 'choose' : 'use';
        if (goLabel) goLabel.textContent = detail
          ? (draft === detail.name ? sheetGo.dataset.lSelected : sheetGo.dataset.lChoose)
          : (this.addonOn ? sheetGo.dataset.lUse : sheetGo.dataset.lAdd);
      };
      /* Kachel sichtbar machen, ohne dass sie unter der klebenden Gruppen-Überschrift landet. */
      const revealStone = el => {
        if (!el || !sheetBody || sheetBody.hidden) return;
        const box = sheetBody.getBoundingClientRect();
        const r = el.getBoundingClientRect();
        if (r.top < box.top + 96) sheetBody.scrollTop += r.top - box.top - 96;
        else if (r.bottom > box.bottom - 12) sheetBody.scrollTop += r.bottom - box.bottom + 12;
      };
      /* Fokus auf den Wähl-Knopf der gewählten Kachel (die Kachel selbst ist nur ein Rahmen). */
      const focusCurrentStone = () => {
        const cur = sheet?.querySelector('[data-atc-stone].is-on');
        revealStone(cur);
        cur?.querySelector('[data-atc-stone-pick]')?.focus({ preventScroll: true });
      };
      const popStone = el => {
        el.classList.remove('is-pop');
        void el.offsetWidth;
        el.classList.add('is-pop');
      };

      /* ---------- Detailansicht ----------
         Streifen zum Wischen (Scroll-Snap), Pfeile, Zähler, Vorschaubilder. Der Hinweis zum
         Beispielring steht nur auf der 3D-Folie. */
      const paneSlides = pane => [...pane.querySelectorAll('[data-atc-dslide]')];
      const markDetail = i => {
        if (!detail) return;
        const pane = detail.pane;
        const slides = paneSlides(pane);
        detail.index = i;
        pane.querySelectorAll('[data-atc-dthumb]').forEach(thumb => thumb.setAttribute('aria-current', String(Number(thumb.dataset.atcDthumb) === i)));
        const count = pane.querySelector('[data-atc-dcount]');
        if (count) count.textContent = (i + 1) + ' / ' + slides.length;
        const prev = pane.querySelector('[data-atc-dprev]');
        const next = pane.querySelector('[data-atc-dnext]');
        const active = document.activeElement;
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === slides.length - 1;
        /* Ein gesperrter Pfeil verliert den Fokus: dann bekommt ihn der Streifen (Pfeiltasten gehen weiter). */
        if ((active === prev && prev.disabled) || (active === next && next.disabled)) pane.querySelector('[data-atc-dtrack]')?.focus({ preventScroll: true });
        const note = pane.querySelector('[data-atc-dnote]');
        if (note) note.hidden = !slides[i]?.hasAttribute('data-atc-d3d');
      };
      const goDetail = (i, instant) => {
        if (!detail) return;
        const track = detail.pane.querySelector('[data-atc-dtrack]');
        const slides = paneSlides(detail.pane);
        if (!track || !slides.length) return;
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: i * track.clientWidth, behavior: instant || reduceMotion.matches ? 'auto' : 'smooth' });
        markDetail(i);
      };
      const openDetail = (name, trigger) => {
        if (!detailWrap || !sheetBody) return;
        const pane = panes.find(p => p.dataset.setName === name);
        if (!pane) return;
        detail = { name, pane, index: 0, scroll: sheetBody.scrollTop, trigger: trigger || null };
        panes.forEach(p => { p.hidden = p !== pane; });
        sheetBody.hidden = true;
        detailWrap.hidden = false;
        detailWrap.scrollTop = 0;
        goDetail(0, true);
        renderSheet();
        detailBack?.focus({ preventScroll: true });
      };
      /* refocus = false, wenn danach etwas anderes den Fokus bekommt oder das Fenster zugeht. */
      const closeDetail = refocus => {
        if (!detail) return;
        const d = detail;
        detail = null;
        if (detailWrap) detailWrap.hidden = true;
        if (sheetBody) {
          sheetBody.hidden = false;
          sheetBody.scrollTop = d.scroll;
        }
        renderSheet();
        if (refocus !== false && d.trigger?.isConnected) d.trigger.focus({ preventScroll: true });
      };
      /* Wischen im Streifen: Vorschaubilder, Zähler und Pfeile folgen der Position. */
      panes.forEach(pane => {
        const track = pane.querySelector('[data-atc-dtrack]');
        if (!track) return;
        let ticking = false;
        on(track, 'scroll', () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            ticking = false;
            if (!detail || detail.pane !== pane) return;
            const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
            if (i !== detail.index) markDetail(i);
          });
        }, { passive: true });
      });

      /* trigger = der angetippte Knopf. Safari fokussiert Buttons beim Antippen nicht, deshalb
         kommt der Fokus beim Schließen über ihn zurück, nicht über activeElement. */
      const openSheet = trigger => {
        if (!sheet || !sheetPanel || !SETS.length) return;
        clearTimeout(this.sheetHide);
        lastFocus = trigger || document.activeElement;
        draft = this.pick;
        /* Das Fenster öffnet immer im Raster, nie in einer alten Detailansicht. */
        detail = null;
        if (detailWrap) detailWrap.hidden = true;
        if (sheetBody) sheetBody.hidden = false;
        renderSheet();
        sheet.hidden = false;
        document.documentElement.classList.add('atc-locked');
        if (sheetBody) sheetBody.scrollTop = 0;
        void sheetPanel.offsetWidth; /* Startlage festschreiben, sonst fährt das Fenster nicht ein */
        sheet.classList.add('is-open');
        focusCurrentStone();
      };
      const closeSheet = commit => {
        if (!sheet || sheet.hidden) return;
        closeDetail(false);
        const chosen = draft;
        draft = null;
        sheet.classList.remove('is-open');
        document.documentElement.classList.remove('atc-locked');
        clearTimeout(this.sheetHide);
        this.sheetHide = setTimeout(() => { sheet.hidden = true; }, reduceMotion.matches ? 0 : 420);
        if (commit && chosen) {
          this.pick = chosen;
          renderPick();
          setAddon(true);
        }
        const back = lastFocus && lastFocus !== document.body && document.contains(lastFocus) ? lastFocus : stRow;
        back?.focus?.({ preventScroll: true });
      };
      stOpeners.forEach(btn => on(btn, 'click', () => openSheet(btn)));
      /* Reihenfolge: schließen → Plus → zurück → Pfeile → Vorschaubild → Wähl-Knopf → Knopf unten. */
      on(sheet, 'click', e => {
        if (e.target.closest('[data-atc-sheet-close]')) { closeSheet(false); return; }
        if (!draft) return;
        /* Plus auf der Kachel: Details öffnen, ohne das Set zu wählen. */
        const detailButton = e.target.closest('[data-atc-stone-detail]');
        if (detailButton) {
          const tile = detailButton.closest('[data-atc-stone]');
          if (tile) openDetail(tile.dataset.setName, detailButton);
          return;
        }
        if (e.target.closest('[data-atc-detail-back]')) { closeDetail(); return; }
        if (e.target.closest('[data-atc-dprev]')) { goDetail(detail ? detail.index - 1 : 0); return; }
        if (e.target.closest('[data-atc-dnext]')) { goDetail(detail ? detail.index + 1 : 0); return; }
        const dthumb = e.target.closest('[data-atc-dthumb]');
        if (dthumb) { goDetail(Number(dthumb.dataset.atcDthumb) || 0); return; }
        const pick = e.target.closest('[data-atc-stone-pick]');
        if (pick) {
          const stone = pick.closest('[data-atc-stone]');
          if (!stone) return;
          draft = stone.dataset.setName;
          popStone(stone);
          renderSheet();
          return;
        }
        if (e.target.closest('[data-atc-sheet-go]')) {
          if (sheetGo?.dataset.action === 'choose' && detail) {
            /* Set als Entwurf übernehmen und zurück ins Raster an seine Kachel. */
            const name = detail.name;
            draft = name;
            closeDetail(false);
            const chosen = SETS.find(set => set.name === name);
            if (chosen) popStone(chosen.el);
            focusCurrentStone();
          } else {
            closeSheet(true);
          }
        }
      });
      /* Escape: aus der Detailansicht zurück ins Raster, sonst schließen ohne zu übernehmen.
         Pfeiltasten blättern in der Detailansicht. Tab bleibt im Fenster. Die Listener am
         document prüfen zuerst, ob ihr Fenster noch im Dokument steckt (Theme-Editor rendert neu). */
      on(document, 'keydown', e => {
        if (!sheet || !sheet.isConnected || sheet.hidden || !draft) return;
        if (e.key === 'Escape') {
          e.preventDefault();
          if (detail) closeDetail(); else closeSheet(false);
          return;
        }
        if (detail && (e.key === 'ArrowLeft' || e.key === 'ArrowRight')) {
          e.preventDefault();
          goDetail(detail.index + (e.key === 'ArrowRight' ? 1 : -1));
          return;
        }
        if (e.key !== 'Tab') return;
        const items = [...sheetPanel.querySelectorAll('button, [tabindex="0"]')].filter(el => !el.disabled && el.getClientRects().length > 0);
        if (!items.length) return;
        const firstItem = items[0];
        const lastItem = items[items.length - 1];
        if (!sheetPanel.contains(document.activeElement)) { e.preventDefault(); firstItem.focus(); return; }
        if (e.shiftKey && document.activeElement === firstItem) { e.preventDefault(); lastItem.focus(); }
        else if (!e.shiftKey && document.activeElement === lastItem) { e.preventDefault(); firstItem.focus(); }
      });
      /* Theme-Editor: einen Steinset-Block anklicken öffnet das Fenster an dieser Kachel.
         Ist dabei eine Detailansicht offen, geht es zurück ins Raster. */
      on(document, 'shopify:block:select', e => {
        if (!sheet || !sheet.isConnected || !sheet.contains(e.target)) return;
        if (sheet.hidden || !draft) openSheet();
        closeDetail(false);
        revealStone(e.target);
      });
      on(document, 'shopify:block:deselect', e => { if (sheet && sheet.isConnected && sheet.contains(e.target)) closeSheet(false); });

      this.updateOffer();

      /* Sterne: springen zu den Bewertungen dieser Section, sonst zum eingestellten Ziel. */
      const ratingLink = this.querySelector('[data-reviews-link]');
      on(ratingLink, 'click', event => {
        if (!(ratingLink.getAttribute('href') || '').startsWith('#')) return;
        let target = this.querySelector('[data-atc-reviews]');
        const key = (ratingLink.dataset.target || '').trim();
        if (!target && key) {
          target = document.getElementById(key.replace(/^#/, ''));
          if (!target) target = [...document.querySelectorAll('[id]')].find(el => el.id.endsWith('__' + key));
          if (!target) { try { target = document.querySelector(key); } catch {} }
        }
        if (!target) target = document.getElementById(ratingLink.hash.slice(1));
        if (!target) target = document.querySelector('.aty-reviews, #judgeme_product_reviews, #looxReviews');
        if (!target) return;
        event.preventDefault();
        const offset = parseFloat(getComputedStyle(this).getPropertyValue('--sticky-top')) || 24;
        window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - offset, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
        const hadTabindex = target.hasAttribute('tabindex');
        if (!hadTabindex) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
        if (!hadTabindex) target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
      });

      on(this.form, 'submit', async event => {
        if (event.submitter && !event.submitter.matches('[data-main-buy],[data-sticky-buy]')) return;
        event.preventDefault();
        if (this.pending) return;
        const radio = this.radios.find(r => r.checked && !r.disabled);
        if (!radio) { if (this.error) { this.error.textContent = this.dataset.selectError; this.error.hidden = false; } return; }
        this.pending = true;
        if (this.error) this.error.hidden = true;
        this.updateOffer();
        /* Mit Edelstein-Zusatz gehen beide Artikel in einem Aufruf in den Warenkorb, das Set
           mit derselben Eigenschaft wie auf der Gemstone-Seite ("Gemstone set 1: Rainbow"). */
        const items = [{ id: radio.value, quantity: 1 }];
        if (this.addonOn && addon && this.pick) {
          items.push({ id: addon.dataset.addonVariant, quantity: 1, properties: { [addon.dataset.property || 'Gemstone set 1']: this.pick } });
        }
        try {
          const response = await fetch(this.dataset.addUrl, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items }) });
          const data = await response.json();
          if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : this.dataset.error);
          window.location.assign(this.dataset.cartUrl);
        } catch (error) {
          if (!this.isConnected) return;
          if (this.error) { this.error.textContent = error.message || this.dataset.error; this.error.hidden = false; }
          this.pending = false;
          this.updateOffer();
        }
      });

      /* Galerie wie im Kit: ein Streifen für alle Medien. Handy wischt, Desktop steuert ihn
         über die Vorschaubilder; Punkte und Vorschaubilder stehen in derselben Reihenfolge. */
      const track = this.querySelector('[data-gal-track]');
      const slides = [...this.querySelectorAll('[data-slide]')];
      const thumbs = [...this.querySelectorAll('[data-thumb]')];
      const dots = [...this.querySelectorAll('[data-gal-dot]')];
      const view3dBtn = this.querySelector('[data-view3d]');
      let index = 0;
      const pauseSlide = slide => {
        slide.querySelectorAll('video').forEach(video => video.pause());
        slide.querySelectorAll('iframe').forEach(frame => {
          try {
            const origin = new URL(frame.src, location.href).origin;
            if (/youtube/.test(origin)) frame.contentWindow?.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: [] }), origin);
            if (/vimeo/.test(origin)) frame.contentWindow?.postMessage(JSON.stringify({ method: 'pause' }), origin);
          } catch {}
        });
      };
      const markSlide = i => {
        index = i;
        thumbs.forEach((thumb, n) => { thumb.classList.toggle('is-on', n === i); thumb.setAttribute('aria-pressed', String(n === i)); });
        dots.forEach((dot, n) => { dot.classList.toggle('is-on', n === i); if (n === i) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
        slides.forEach((slide, n) => { if (n !== i) pauseSlide(slide); });
        if (view3dBtn) view3dBtn.classList.toggle('is-active', slides[i]?.dataset.mediaType === 'model');
      };
      const goSlide = (i, instant) => {
        if (!track || !slides.length) return;
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: i * track.clientWidth, behavior: instant || reduceMotion.matches ? 'auto' : 'smooth' });
        markSlide(i);
      };
      if (track) {
        let ticking = false;
        on(track, 'scroll', () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            ticking = false;
            const i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
            if (i !== index) markSlide(i);
          });
        }, { passive: true });
        on(track, 'keydown', e => {
          if (e.target !== track) return;
          if (e.key === 'ArrowRight') { e.preventDefault(); goSlide(index + 1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); goSlide(index - 1); }
        });
        /* Nach dem Drehen oder Verkleinern bleibt dasselbe Bild stehen. */
        on(window, 'resize', () => goSlide(index, true));
      }
      thumbs.forEach((thumb, i) => on(thumb, 'click', () => goSlide(i)));
      dots.forEach((dot, i) => on(dot, 'click', () => goSlide(i)));
      if (view3dBtn) on(view3dBtn, 'click', () => { const t = parseInt(view3dBtn.dataset.target || '0', 10); goSlide(isNaN(t) ? 0 : t); });
      selectVariantMedia = (radio, instant) => {
        const mediaId = radio?.dataset.mediaId;
        if (!mediaId) return;
        const mediaIndex = slides.findIndex(slide => slide.dataset.mediaId === mediaId);
        if (mediaIndex >= 0 && mediaIndex !== index) goSlide(mediaIndex, instant);
      };

      const dialog = this.querySelector('dialog');
      const zoomContent = this.querySelector('[data-zoom-content]');
      const openZoom = btn => {
        const image = btn.querySelector('img');
        if (!image || !dialog || typeof dialog.showModal !== 'function') return;
        const clone = image.cloneNode(true);
        clone.removeAttribute('loading');
        clone.removeAttribute('sizes');
        clone.removeAttribute('srcset');
        clone.removeAttribute('fetchpriority');
        zoomContent.replaceChildren(clone);
        dialog.showModal();
      };
      this.querySelectorAll('.image-open').forEach(btn => on(btn, 'click', () => openZoom(btn)));
      on(this.querySelector('[data-close]'), 'click', () => dialog.close());
      on(dialog, 'click', e => { if (e.target === dialog) dialog.close(); });
      selectVariantMedia(this.radios.find(r => r.checked && !r.disabled), true);

      /* FAQ im Hallmark-Muster: die Antwortfläche (.atc-panel) fährt in Höhe und Deckkraft auf und
         zu (460 ms auf, 340 ms zu), das Plus dreht dabei zum ×. Bei „weniger Bewegung“ oder ohne
         WAAPI klappt der Browser das <details> nativ um, nur ohne Bewegung. */
      this.querySelectorAll('details.atc-q').forEach(item => {
        const summary = item.querySelector('summary');
        const panel = item.querySelector('.atc-panel');
        if (!summary || !panel || typeof panel.animate !== 'function') return;
        let run = null;
        on(summary, 'click', event => {
          /* „Weniger Bewegung“ wird bei jedem Klick geprüft: dann schaltet der Browser nativ um. */
          if (reduceMotion.matches) return;
          event.preventDefault();
          if (run) { run.cancel(); run = null; }
          if (!item.open || item.classList.contains('is-closing')) {
            item.classList.remove('is-closing');
            item.open = true;
            run = panel.animate(
              [{ height: '0px', opacity: 0 }, { height: panel.offsetHeight + 'px', opacity: 1 }],
              { duration: 460, easing: 'cubic-bezier(.22, 1, .36, 1)' }
            );
            run.onfinish = () => { run = null; };
          } else {
            item.classList.add('is-closing');
            run = panel.animate(
              [{ height: panel.offsetHeight + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
              { duration: 340, easing: 'cubic-bezier(.4, 0, .2, 1)' }
            );
            run.onfinish = () => { run = null; item.open = false; item.classList.remove('is-closing'); };
          }
        });
        this.lifecycle.signal.addEventListener('abort', () => { if (run) run.cancel(); }, { once: true });
      });

      if (this.mainBuy && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(([entry]) => { const st = this.querySelector('[data-sticky]'); if (st) st.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0; });
        this.observer.observe(this.mainBuy);
      }
      on(document, 'shopify:block:select', event => { const radio = event.target.querySelector('[data-offer]'); if (radio && !radio.disabled) { radio.checked = true; this.updateOffer(); } });

      /* Lieferdatum: heute + N Werktage (bei einer Spanne der späteste Tag), im Format der
         Shop-Sprache, z. B. "Thu, Oct 1". Liquid hat es schon vorgeschrieben. */
      const elDelivery = this.querySelector('[data-delivery]');
      if (elDelivery) {
        const addWorkdays = n => {
          const d = new Date();
          let added = 0;
          while (added < n) {
            d.setDate(d.getDate() + 1);
            if (d.getDay() !== 0 && d.getDay() !== 6) added += 1;
          }
          return d;
        };
        const daysMin = parseInt(this.dataset.leadDays || '1', 10) || 1;
        const daysMax = parseInt(this.dataset.leadDaysMax || '0', 10) || 0;
        try {
          elDelivery.textContent = addWorkdays(Math.max(daysMin, daysMax)).toLocaleDateString(this.dataset.locale || 'en', { weekday: 'short', day: 'numeric', month: 'short' });
        } catch {}
      }

      /* Galerie klebt unter der Navigation: Versatz aus deren echter Höhe (wie im Kit),
         mindestens der Wert aus der Einstellung "Abstand Galerie oben". */
      const nav = document.querySelector('.aty-nav--solid');
      if (nav) {
        const base = parseFloat(getComputedStyle(this).getPropertyValue('--sticky-top')) || 0;
        const setStickyTop = () => this.style.setProperty('--sticky-top', Math.max(base, nav.offsetHeight + 20) + 'px');
        setStickyTop();
        on(window, 'resize', setStickyTop);
      }

      /* Schritt-Videos: stumm in Schleife, nur solange sie im Bild sind. Bei "weniger
         Bewegung" bleibt das Standbild stehen und man startet selbst. */
      const videos = [...this.querySelectorAll('[data-atc-video]')];
      if (videos.length) {
        const play = video => { const promise = video.play(); if (promise && typeof promise.catch === 'function') promise.catch(() => {}); };
        videos.forEach(video => { video.muted = true; });
        if (reduceMotion.matches) {
          videos.forEach(video => { video.controls = true; video.preload = 'metadata'; });
        } else if ('IntersectionObserver' in window) {
          this.videoObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => { if (entry.isIntersecting) play(entry.target); else entry.target.pause(); });
          }, { rootMargin: '120px 0px', threshold: 0.2 });
          videos.forEach(video => this.videoObserver.observe(video));
        } else {
          videos.forEach(play);
        }
      }

      /* Vorher/Nachher wie im Kit: Ziehen mit Maus oder Finger, Pfeiltasten am Griff (Shift =
         größere Schritte, Pos1/Ende = Anschlag). touch-action: pan-y lässt senkrechtes Wischen
         die Seite scrollen. Beim ersten Sichtkontakt schwenkt der Griff einmal kurz, damit man
         sieht, dass man ziehen kann (nicht bei "weniger Bewegung", nicht nach eigenem Anfassen). */
      this.compareObservers = [];
      this.querySelectorAll('[data-atc-compare]').forEach(stage => {
        const handle = stage.querySelector('[data-atc-compare-handle]');
        const labelB = stage.dataset.labelBefore || '';
        const labelA = stage.dataset.labelAfter || '';
        let pos = 50;
        let dragging = false;
        let touched = false;
        let hintRaf = 0;
        const clamp01 = v => (v < 0 ? 0 : v > 1 ? 1 : v);
        const setPos = p => {
          pos = p < 0 ? 0 : p > 100 ? 100 : p;
          stage.style.setProperty('--pos', pos + '%');
          if (handle) {
            handle.setAttribute('aria-valuenow', Math.round(pos));
            handle.setAttribute('aria-valuetext', Math.round(pos) + '% ' + labelB + ', ' + Math.round(100 - pos) + '% ' + labelA);
          }
        };
        const fromEvent = e => {
          const r = stage.getBoundingClientRect();
          if (r.width) setPos((e.clientX - r.left) / r.width * 100);
        };
        const stopHint = () => {
          touched = true;
          if (hintRaf) cancelAnimationFrame(hintRaf);
          hintRaf = 0;
        };
        this.lifecycle.signal.addEventListener('abort', stopHint, { once: true });
        on(stage, 'pointerdown', e => {
          if (e.button !== undefined && e.button !== 0) return;
          stopHint();
          dragging = true;
          stage.classList.add('is-drag');
          try { stage.setPointerCapture(e.pointerId); } catch {}
          fromEvent(e);
          if (e.pointerType === 'mouse' && handle) { e.preventDefault(); handle.focus({ preventScroll: true }); }
        });
        on(stage, 'pointermove', e => { if (dragging) fromEvent(e); });
        ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(type => on(stage, type, () => { dragging = false; stage.classList.remove('is-drag'); }));
        on(handle, 'keydown', e => {
          const step = e.shiftKey ? 10 : 4;
          let next = null;
          if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') next = pos - step;
          if (e.key === 'ArrowRight' || e.key === 'ArrowUp') next = pos + step;
          if (e.key === 'Home') next = 0;
          if (e.key === 'End') next = 100;
          if (next === null) return;
          e.preventDefault();
          stopHint();
          setPos(next);
        });
        const hint = () => {
          if (touched || reduceMotion.matches) return;
          const keys = [[0, 50], [520, 30], [1180, 70], [1650, 50]];
          const ease = t => (t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2);
          let t0 = null;
          const tick = now => {
            if (touched) return;
            if (t0 === null) t0 = now;
            const t = now - t0;
            let i = 1;
            while (i < keys.length - 1 && t > keys[i][0]) i++;
            const a = keys[i - 1];
            const b = keys[i];
            setPos(a[1] + (b[1] - a[1]) * ease(clamp01((t - a[0]) / (b[0] - a[0]))));
            if (t < keys[keys.length - 1][0]) hintRaf = requestAnimationFrame(tick);
            else { setPos(50); hintRaf = 0; }
          };
          hintRaf = requestAnimationFrame(tick);
        };
        setPos(50);
        if ('IntersectionObserver' in window) {
          const seen = new IntersectionObserver(entries => {
            if (!entries[0].isIntersecting) return;
            seen.disconnect();
            setTimeout(hint, 350);
          }, { threshold: 0.55 });
          seen.observe(stage);
          this.compareObservers.push(seen);
        }
      });

      /* Bewertungs-Laufband im Theme-Editor: eine angeklickte Bewertung bleibt stehen und
         rückt ins Bild, beim Abwählen läuft das Band weiter. Im Shop ohne Wirkung. */
      const rvList = this.querySelector('[data-atc-marquee]');
      const rvTrack = rvList?.querySelector('.atc-reviews-track');
      if (rvList && rvTrack) {
        on(document, 'shopify:block:select', e => {
          if (!rvList.contains(e.target)) return;
          rvTrack.style.animation = 'none';
          rvList.scrollLeft = 0;
          rvList.scrollLeft = Math.max(0, e.target.getBoundingClientRect().left - rvList.getBoundingClientRect().left - 24);
        });
        on(document, 'shopify:block:deselect', e => {
          if (!rvList.contains(e.target)) return;
          rvTrack.style.animation = '';
          rvList.scrollLeft = 0;
        });
      }
    }
    disconnectedCallback() {
      this.lifecycle?.abort();
      this.observer?.disconnect();
      this.videoObserver?.disconnect();
      this.compareObservers?.forEach(observer => observer.disconnect());
      this.querySelector('dialog')?.close();
      /* Steinfenster zurück an seinen Platz: geht die Section weg, geht es mit; wird sie nur
         verschoben, findet das nächste connectedCallback es wieder. */
      clearTimeout(this.sheetHide);
      document.documentElement.classList.remove('atc-locked');
      if (this.sheet) {
        this.sheet.classList.remove('is-open');
        this.sheet.hidden = true;
        if (this.sheetHome && this.sheetHome !== this.sheet.parentNode) this.sheetHome.appendChild(this.sheet);
      }
      this.initialized = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atelaye-workshops"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Hallmark: Zeitleiste und Abschlusslinie laufen einmal ab, sobald sie im Bild sind.
       Ohne JS oder bei reduzierter Bewegung steht sofort der Endzustand. Der Hero läuft per CSS beim Laden. */
    function init(scope) {
      var hosts = scope.classList && scope.classList.contains('aty-workshop') ? [scope] : scope.querySelectorAll('.aty-workshop');
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      Array.prototype.forEach.call(hosts, function (host) {
        if (host.getAttribute('data-aw-ready')) { return; }
        host.setAttribute('data-aw-ready', '1');
        if (reduce || !('IntersectionObserver' in window)) { return; }
        var items = host.querySelectorAll('[data-aw-reveal]');
        if (!items.length) { return; }
        host.classList.add('is-anim');
        Array.prototype.forEach.call(items, function (el) {
          var io = new IntersectionObserver(function (entries) {
            if (!entries.some(function (en) { return en.isIntersecting; })) { return; }
            io.disconnect();
            el.classList.add('is-on');
          }, { rootMargin: el.hasAttribute('data-aw-how') ? '0px 0px -45% 0px' : '0px 0px -10% 0px' });
          io.observe(el);
        });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(document); });
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
